<template>
  <VDialog
    v-model="aberto"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <LoadingDialog ref="janelaCarregando" />
    <FormRenderDialog
      ref="formDialog"
      @fichaSalva="verificarAcessoAtendimentoProntuario"
      :idComanda="comanda.id"
      :comandaUsr="this.comanda"
    />
    <LogComandas
      v-model="logComandas"
      :codigoComanda="comanda.id"
    ></LogComandas>
    <VCard>
      <VToolbar
        card
        fixed
        app
        dark
        color="primary"
        height="40"
        clipped-right
        clipped-left
        hidden-print-only
      >
        <VFlex
          xs1
          sm1
          md1
          lg1
          xl1
          v-if="
            parametros.numeracaoDaComandaManual &&
            (comandaComStatusPresenteOuExecutado ||
              (this.comanda.idNumeroManual != null &&
                this.comanda.idNumeroManual != this.comanda.id))
          "
          class="subheading"
        >
          <VTextField
            label="Comanda"
            v-model="comanda.idNumeroManual"
            min="0"
            type="number"
            hint="Númeração manual da comanda"
            :disabled="somenteLeitura"
            v-on:keydown="eventoNumerico"
          />
          <!-- light solo  -->
        </VFlex>
        <VToolbarTitle class="subheading" hidden-print-only>
          <span hidden-print-only>{{ titulo }}</span>
        </VToolbarTitle>
        <VSpacer />

        <VToolbarItems hidden-print-only>
          <VLayout hidden-print-only>
            <VBtn icon dark @click="impressaoTermica" hint="Imprimir">
              <VIcon hint="Imprimir">receipt_long </VIcon>
            </VBtn>
            <VBtn icon dark @click="abrirDialogPrint" hint="Imprimir">
              <VIcon hint="Imprimir"> print </VIcon>
            </VBtn>
            <VTooltip bottom>
              <template v-slot:activator="{ on }">
                <VBtn
                  v-on="on"
                  icon
                  dark
                  :disabled="!clienteSelecionado"
                  @click="abrirHistoricoSaldoServicos()"
                >
                  <VIcon>history</VIcon>
                </VBtn>
              </template>
              <span>Histórico/saldo</span>
            </VTooltip>
            <VTooltip>
              <template v-slot:activator="{ on }">
                <VBtn
                  v-on="on"
                  icon
                  dark
                  :disabled="!comanda.cliente.id"
                  slot="activator"
                  @click="servicoContratadoDialog = true"
                >
                  <VIcon>assignment</VIcon>
                </VBtn>
              </template>
              <span>Ficha de anamnese</span>
            </VTooltip>
            <VBtn
              icon
              dark
              @click="fechar(true)"
              :disabled="this.requisicaoEmAndamento"
            >
              <VIcon>close</VIcon>
            </VBtn>
          </VLayout>
        </VToolbarItems>
      </VToolbar>
      <VCard>
        <VCardText>
          <VLayout column wrap>
            <VCard style="margin-top: 3%; margin-bottom: 0.2%" class="pa-3">
              <VCardText>
                <VForm hidden-print-only>
                  <VLayout row wrap justify-space-around>
                    <VFlex xs12 sm12 md4>
                      <AutocompleteCliente
                        :somente-leitura="!novoRegistro || somenteLeitura"
                        :permitir-adicionar="true"
                        :permitir-editar="false"
                        @input="trocarCliente"
                        v-model="comanda.cliente"
                      />
                    </VFlex>
                    <VFlex xs12 sm12 md3>
                      <VTextField
                        label="Telefone"
                        prepend-icon="phone"
                        disabled
                        v-model="comanda.cliente.telefoneGeral"
                        color="primary"
                      />
                    </VFlex>
                    <VFlex xs12 sm12 md3>
                      <SelecaoData
                        label="Data"
                        v-model="comanda.data"
                        :somente-leitura="somenteLeitura"
                        :change="alterando"
                        :min="dataIso(new Date())"
                        :rules="[rules.obrigatorio()]"
                      />
                    </VFlex>
                    <VFlex xs12 sm12 md1>
                      <VCheckbox
                        color="primary"
                        v-model="comanda.noiva"
                        label="Noiva"
                        :disabled="somenteLeitura"
                      />
                    </VFlex>
                  </VLayout>
                </VForm>
              </VCardText>
            </VCard>
          </VLayout>
          <VExpansionPanel expand v-model="visibilidadePaineis">
            <VExpansionPanelContent>
              <template v-slot:header>
                <span class="title">Serviços</span>
              </template>
              <VCard>
                <VCardText>
                  <VLayout column wrap>
                    <VForm ref="formInclusaoEvento">
                      <VLayout wrap justify-space-between hidden-print-only>
                        <VFlex xs12 sm12 md1>
                          <VCheckbox
                            label="Avulso"
                            color="primary"
                            :class="
                              $vuetify.breakpoint.smAndDown ? 'mt-0 pt-0' : ''
                            "
                            v-model="novoEvento.servicoAvulso"
                            id="avulso"
                            :disabled="somenteLeitura"
                          />
                        </VFlex>
                        <VFlex xs6 sm5 md1>
                          <VAutocomplete
                            v-model="novoEvento.tipoServico"
                            label="Tipo"
                            :items="retornaTipoServicos"
                            :disabled="
                              !novoEvento.servicoAvulso || somenteLeitura
                            "
                            item-value="id"
                            item-text="nome"
                            return-object
                            color="primary"
                          />
                        </VFlex>
                        <VFlex xs6 sm5 md2>
                          <VAutocomplete
                            v-model="novoEvento.servico"
                            multiple
                            label="Serviço"
                            :items="retornaServicos"
                            color="primary"
                            item-value="id"
                            item-text="nome"
                            :rules="[rules.obrigatorio()]"
                            :disabled="
                              somenteLeitura || retornaServicos.length < 1
                            "
                            return-object
                            :success="this.servicosAdquiridos.length > 0"
                          />
                        </VFlex>
                        <VFlex xs6 sm12 md1 mr-5>
                          <VCheckbox
                            label="Preferencial"
                            color="primary"
                            :class="
                              $vuetify.breakpoint.smAndDown ? 'mt-0 pt-0' : ''
                            "
                            v-model="novoEvento.profissionalPreferencial"
                            :disabled="
                              (novoEvento.profissional &&
                                !novoEvento.profissional.id) ||
                              somenteLeitura
                            "
                          />
                        </VFlex>
                        <VFlex xs6 sm5 md1>
                          <VAutocomplete
                            v-model="novoEvento.profissional"
                            label="Profissional"
                            :items="retornaProfissionais"
                            :disabled="somenteLeitura"
                            item-value="id"
                            item-text="nomeFantasia"
                            color="primary"
                            :rules="[rules.obrigatorio()]"
                            return-object
                          />
                        </VFlex>
                        <VFlex xs6 sm5 md1>
                          <VAutocomplete
                            ref="espaco"
                            v-model="novoEvento.espaco"
                            label="Espaço"
                            item-value="id"
                            item-text="nome"
                            :items="espacos"
                            color="primary"
                            :disabled="somenteLeitura"
                            :rules="[rules.obrigatorio()]"
                            return-object
                          />
                        </VFlex>
                        <VFlex xs6 sm5 md1>
                          <VTextField
                            ref="duracao"
                            :mask="mascaraDuracao"
                            v-model="novoEvento.duracao"
                            label="Duração"
                            color="primary"
                            :rules="[rules.obrigatorio()]"
                            :disabled="somenteLeitura"
                            return-masked-value
                          />
                        </VFlex>
                        <VFlex xs6 sm5 md1>
                          <VAutocomplete
                            ref="horario"
                            v-model="novoEvento.horario"
                            label="Horário"
                            :items="horarios"
                            color="primary"
                            :rules="[rules.obrigatorio()]"
                            :disabled="somenteLeitura"
                            item-value="value"
                            item-text="value"
                          />
                        </VFlex>
                        <VFlex xs4 sm5 md1>
                          <VAutocomplete
                            v-model="novoEvento.situacao"
                            label="Situação"
                            :items="situacoes"
                            :rules="[rules.obrigatorio()]"
                            :disabled="somenteLeitura"
                            return-object
                          />
                        </VFlex>
                        <VFlex
                          xs12
                          sm5
                          md1
                          text-xs-right
                          text-sm-left
                          text-md-left
                        >
                          <BotaoAdicionarGrid
                            :disabled="somenteLeitura"
                            @click="adicionarMultiEvento(novoEvento)"
                          />
                        </VFlex>
                      </VLayout>
                    </VForm>
                    <VFlex xs12 mt-3>
                      <VForm>
                        <VLayout wrap>
                          <VFlex xs12>
                            <VDataTable
                              hide-actions
                              :headers="cabecalhosGridServicos"
                              :items="comanda.eventos"
                              class="elevation-1"
                              hidden-print-only
                            >
                              <template v-slot:items="props">
                                <td v-if="props.item.servicoAvulso">Avulso</td>
                                <td v-else>
                                  {{ props.item.servico.utilizacaoPacote }}
                                </td>
                                <td>
                                  <span>{{ props.item.servico.nome }}</span>
                                </td>
                                <td>
                                  <span v-if="bloquearEdicaoEvento(props.item)">
                                    {{ props.item.espaco.nome }}
                                  </span>
                                  <VEditDialog
                                    v-else
                                    :return-value.sync="props.item.espaco"
                                    lazy
                                    large
                                    save-text="Atualizar"
                                    cancel-text="Cancelar"
                                    @open="inicializarHelperEspaco(props.item)"
                                    @save="salvarEspacoDialog(props.item)"
                                  >
                                    {{ props.item.espaco.nome }}
                                    <div slot="input" class="mt-3 mb-2">
                                      <VSelect
                                        v-model="itemEditado.espaco"
                                        label="Espaço"
                                        :items="espacos"
                                        item-value="id"
                                        item-text="nome"
                                        color="primary"
                                        return-object
                                      />
                                    </div>
                                  </VEditDialog>
                                </td>
                                <td>
                                  <span v-if="bloquearEdicaoEvento(props.item)">
                                    {{
                                      listarProfissionais(
                                        props.item.profissionais
                                      )
                                    }}
                                  </span>
                                  <VEditDialog
                                    v-else
                                    lazy
                                    large
                                    persistent
                                    save-text="Atualizar"
                                    cancel-text="Cancelar"
                                    @open="
                                      inicializarHelperProfissionais(props.item)
                                    "
                                    @save="
                                      salvarProfissionaisDialog(props.item)
                                    "
                                    @cancel="close"
                                  >
                                    {{
                                      listarProfissionais(
                                        props.item.profissionais
                                      )
                                    }}
                                    <div
                                      slot="input"
                                      class="Dropdown-Profissionais mt-3 mb-2"
                                    >
                                      <SelectProfissionais
                                        v-model="profissionaisEvento"
                                        :profissionais-lista="
                                          !parametros.configuracoesServicos
                                            .restringeServicosPorProfissional
                                            ? profissionais
                                            : profissionais.filter(
                                                (s) =>
                                                  s.idServico ===
                                                  props.item.servico.id
                                              )
                                        "
                                      />
                                    </div>
                                  </VEditDialog>
                                </td>
                                <td>
                                  <span v-if="bloquearEdicaoEvento(props.item)">
                                    {{
                                      converterMinutosEmHora(props.item.duracao)
                                    }}
                                  </span>
                                  <VEditDialog
                                    lazy
                                    large
                                    v-else
                                    save-text="Atualizar"
                                    cancel-text="Cancelar"
                                    @open="inicializarHelperDuracao(props.item)"
                                    @save="salvarDuracaoDialog(props.item)"
                                  >
                                    {{
                                      converterMinutosEmHora(props.item.duracao)
                                    }}
                                    <div slot="input" class="mt-3 mb-2">
                                      <VTextField
                                        :mask="mascaraDuracao"
                                        v-model="itemEditado.duracao"
                                        label="Duração"
                                        color="primary"
                                        return-masked-value
                                      />
                                    </div>
                                  </VEditDialog>
                                </td>
                                <td>
                                  <span v-if="bloquearEdicaoEvento(props.item)">
                                    {{
                                      verificarEformatarHora(props.item.hora)
                                    }}
                                  </span>
                                  <VEditDialog
                                    v-else
                                    :return-value.sync="props.item.hora"
                                    lazy
                                    large
                                    save-text="Atualizar"
                                    cancel-text="Cancelar"
                                    @open="inicializarHelperHora(props.item)"
                                    @save="salvarHoraDialog(props.item)"
                                  >
                                    {{
                                      verificarEformatarHora(props.item.hora)
                                    }}
                                    <div slot="input" class="mt-3 mb-2">
                                      <VSelect
                                        v-model="itemEditado.hora"
                                        label="Horário"
                                        :items="horarios"
                                        item-value="value"
                                        item-text="value"
                                        color="primary"
                                      />
                                    </div>
                                  </VEditDialog>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      bloquearEdicaoEvento(props.item) &&
                                      (comanda.fechada ||
                                        !parametros.alterarAgendamentosExecutados)
                                    "
                                    >{{ props.item.situacao }}</span
                                  >
                                  <VEditDialog
                                    v-else
                                    :return-value.sync="props.item.situacao"
                                    lazy
                                    persistent
                                    save-text="Atualizar"
                                    cancel-text="Cancelar"
                                    :ref="`dialogSituacao${props.index}`"
                                    @open="
                                      inicializarHelperProfissionais(props.item)
                                    "
                                  >
                                    {{ props.item.situacao }}
                                    <div slot="input" class="mt-3 mb-2">
                                      <VSelect
                                        v-model="props.item.situacao"
                                        label="Situação"
                                        :items="situacoes"
                                        color="primary"
                                        @change="props.item.emEdicao = true"
                                      />
                                      <SelectProfissionais
                                        v-if="
                                          isSituacaoExecutado(
                                            props.item.situacao
                                          )
                                        "
                                        v-model="profissionaisEvento"
                                        :profissionais-lista="
                                          !parametros.configuracoesServicos
                                            .restringeServicosPorProfissional
                                            ? profissionais
                                            : profissionais.filter(
                                                (s) =>
                                                  s.idServico ===
                                                  props.item.servico.id
                                              )
                                        "
                                      />
                                      <VLayout justify-end>
                                        <VBtn
                                          color="primary"
                                          flat
                                          @click="
                                            cancelarEditDialogSituacao(
                                              props.index
                                            )
                                          "
                                        >
                                          Cancelar
                                        </VBtn>
                                        <VBtn
                                          color="primary"
                                          flat
                                          :disabled="
                                            isSituacaoExecutado(
                                              props.item.situacao
                                            ) &&
                                            isProfissionalNulo(
                                              profissionaisEvento
                                            )
                                          "
                                          @click="
                                            salvarSituacao(
                                              props.index,
                                              props.item
                                            )
                                          "
                                        >
                                          Atualizar
                                        </VBtn>
                                      </VLayout>
                                    </div>
                                  </VEditDialog>
                                </td>
                                <td>
                                  <div
                                    v-if="
                                      props.item.profissionais.responsavel &&
                                      props.item.profissionais.responsavel.id
                                    "
                                  >
                                    <span
                                      v-if="bloquearEdicaoEvento(props.item)"
                                    >
                                      {{
                                        props.item.profissionais.responsavel
                                          .preferencial
                                          ? "Sim"
                                          : "Não"
                                      }}
                                    </span>
                                    <VEditDialog
                                      v-else
                                      :return-value.sync="
                                        props.item.profissionais.responsavel
                                          .preferencial
                                      "
                                      lazy
                                      large
                                      save-text="Atualizar"
                                      cancel-text="Cancelar"
                                    >
                                      {{
                                        props.item.profissionais.responsavel
                                          .preferencial
                                          ? "Sim"
                                          : "Não"
                                      }}
                                      <div slot="input" class="mt-3 mb-2">
                                        <VCheckbox
                                          color="primary"
                                          v-model="
                                            props.item.profissionais.responsavel
                                              .preferencial
                                          "
                                          label="Preferencial"
                                        ></VCheckbox>
                                      </div>
                                    </VEditDialog>
                                  </div>
                                  <div v-else>Não</div>
                                </td>
                                <td>
                                  <!-- Tem desconto-->
                                  <div
                                    v-if="
                                      props.item.desconto != null &&
                                      props.item.desconto.tipo != 'SemDesconto'
                                    "
                                  >
                                    <VTooltip bottom>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <div v-bind="attrs" v-on="on">
                                          <span class="desconto">
                                            {{
                                              formatarDinheiro(
                                                props.item.valorBruto
                                              )
                                            }}
                                          </span>
                                          <span>
                                            {{
                                              formatarDinheiro(
                                                props.item.valorBruto -
                                                  props.item.desconto.valor
                                              )
                                            }}
                                          </span>
                                        </div>
                                      </template>
                                      <span>
                                        {{ props.item.desconto.tipo }}
                                      </span>
                                    </VTooltip>
                                  </div>
                                  <div v-else>
                                    {{
                                      formatarDinheiro(props.item.valorBruto)
                                    }}
                                  </div>
                                </td>
                                <td class="text-xs-right">
                                  <VLayout hidden-print-only>
                                    <span />
                                    <VTooltip bottom>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <VBtn
                                          v-show="
                                            habilitaAssinatura(props.item)
                                          "
                                          :disabled="
                                            !props.item.idFormularioPreenchido
                                          "
                                          :color="
                                            corStatusAssinatura(props.item)
                                          "
                                          v-bind="attrs"
                                          v-on="on"
                                          @click="
                                            mostrarDialogSignatarios(props.item)
                                          "
                                          icon
                                          flat
                                          small
                                        >
                                          <VIcon>verified</VIcon>
                                        </VBtn>
                                      </template>
                                      <span>Assinatura digital</span>
                                    </VTooltip>
                                    <VTooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <VBtn
                                          icon
                                          flat
                                          small
                                          v-on="on"
                                          v-if="
                                            props.item.cortesiaAvulso ||
                                            (props.item.servicoAvulso &&
                                              props.item.valorBruto > 0 &&
                                              props.item.servico
                                                .permiteCortesia &&
                                              parametros.permissoes
                                                .permissoesComanda
                                                .concederCortesia == 'S')
                                          "
                                          @click="
                                            alternarCortesia(
                                              props.index,
                                              props.item
                                            )
                                          "
                                          :disabled="somenteLeitura"
                                        >
                                          <VIcon v-on="on">
                                            {{
                                              props.item.cortesiaAvulso
                                                ? "money_off"
                                                : "attach_money"
                                            }}
                                          </VIcon>
                                        </VBtn>
                                      </template>
                                      <span>
                                        {{
                                          props.item.cortesiaAvulso
                                            ? "Retirar"
                                            : "Conceder"
                                        }}
                                        cortesia
                                      </span>
                                    </VTooltip>
                                    <VTooltip bottom>
                                      <VBtn
                                        v-if="
                                          props.item.idFormularioPreenchido ||
                                          (!bloquearEdicaoEvento(props.item) &&
                                            props.item.servico.formulario)
                                        "
                                        slot="activator"
                                        color="primary"
                                        icon
                                        flat
                                        small
                                        @click="carregarFormulario(props.item)"
                                      >
                                        <VIcon
                                          :color="
                                            getCorIconeFormulario(props.item)
                                          "
                                        >
                                          trending_up
                                        </VIcon>
                                      </VBtn>
                                      <span>
                                        {{ getTooltipFormulario(props.item) }}
                                      </span>
                                    </VTooltip>
                                    <BotaoExcluir
                                      @click="
                                        excluirEvento(props.index, props.item)
                                      "
                                      :disabled="
                                        bloquearEdicaoEvento(props.item)
                                      "
                                    />
                                    <DescontoDialog
                                      class="mr-2"
                                      :labelTitle="'Desconto unitário - Serviço'"
                                      :desconto.sync="comanda.desconto"
                                      v-on:update:desconto="
                                        comanda.desconto = $event
                                      "
                                      :descontoValorTotal="false"
                                      :descontoUnitario="true"
                                      :disabledDescontoUnitario="
                                        temDescontoComanda ||
                                        props.item.cortesiaAvulso ||
                                        somenteLeitura
                                      "
                                      :item="comanda.eventos[props.index]"
                                      v-on:update:itemDesconto="
                                        comanda.eventos[props.index].desconto =
                                          $event
                                      "
                                      :valorTotal="props.item.valorBruto"
                                      :limiteDesconto="parametros.configuracoesGlobais.utilizaDescontoPorProduto
                                                    && comanda.eventos[props.index].servico.permiteDesconto
                                                    && comanda.eventos[props.index].servico.percentualMaximoDesconto != null
                                            ? comanda.eventos[props.index].servico.percentualMaximoDesconto
                                            : parametros.configuracoesUsuario.percentualDesconto"
                                    >
                                    </DescontoDialog>
                                  </VLayout>
                                </td>
                              </template>
                            </VDataTable>
                          </VFlex>
                        </VLayout>
                      </VForm>
                    </VFlex>
                  </VLayout>
                </VCardText>
              </VCard>
            </VExpansionPanelContent>

            <VExpansionPanelContent v-if="parametros.configuracoesServicos.permiteReservarEquipamentos && comanda.eventos.length > 0">
              <template v-slot:header>
                <span class="title">Equipamentos</span>
              </template>
              <VCard>
                <VCardText>
                  <VForm ref="formInclusaoEquipamentos" lazy-validation>
                    <VLayout row wrap justify-space-around hidden-print-only>
                      <VFlex xs12 sm2 md2>
                        <VAutocomplete
                          :items="tiposEquipamentos"
                          label="Tipo"
                          v-model="novoEquipamento.tipo"
                          item-value="id"
                          item-text="descricao"
                          :rules="[rules.obrigatorio()]"
                          :disabled="somenteLeitura"
                          return-object
                        />
                      </VFlex>
                      <VFlex xs12 sm2 md8>
                        <VAutocomplete
                          :items="equipamentos"
                          label="Equipamentos"
                          :disabled="!novoEquipamento.tipo"
                          v-model="novoEquipamento.equipamento"
                          multiple
                          :rules="[rules.obrigatorio()]"
                          item-value="id"
                          item-text="descricao"
                          return-object
                        >
                        <template v-slot:item="{ item }">
                          <div class="equipamentos">
                            <span>{{ item.descricao }}</span><span :class="obterClasseStatusEquipamento(item.status)"><b>{{ obterDescricaoStatusEquipamento(item.status) }}</b></span>
                          </div>
                        </template>
                      </VAutocomplete>
                      </VFlex>
                      <VFlex xs12 sm1 md1 text-xs-right text-md-center>
                        <BotaoAdicionarGrid
                          :disabled="somenteLeitura"
                          @click="adicionarMultiEquipamento(novoEquipamento)"
                        />
                      </VFlex>
                    </VLayout>
                  </VForm>
                  <VLayout>
                    <VFlex md12>
                      <VDataTable
                        hide-actions
                        :headers="cabecalhosGridEquipamento"
                        :items="comanda.equipamentos"
                        class="elevation-1"
                      >
                        <template v-slot:items="props">
                          <td>
                            <span>{{ props.item.descricao }}</span>
                          </td>
                          <td>
                            <VLayout hidden-print-only>
                              <span/>
                              <BotaoExcluir
                                :disabled="somenteLeitura"
                                @click="excluirEquipamento(props.index)"
                              />
                            </VLayout>
                          </td>
                        </template>
                      </VDataTable>
                    </VFlex>
                  </VLayout>
                </VCardText>
              </VCard>
            </VExpansionPanelContent>
            <VExpansionPanelContent>
              <template v-slot:header>
                <span class="title">Produtos</span>
              </template>
              <VCard>
                <VCardText>
                  <VForm ref="formInclusaoProduto" lazy-validation>
                    <VLayout row wrap justify-space-around hidden-print-only>
                      <VFlex xs12 sm2 md2>
                        <VAutocomplete
                          :items="tiposProduto"
                          label="Tipo"
                          v-model="novoProduto.tipo"
                          item-value="id"
                          item-text="nome"
                          :rules="[rules.obrigatorio()]"
                          :disabled="somenteLeitura"
                          return-object
                        />
                      </VFlex>
                      <VFlex xs12 sm3 md4>
                        <VAutocomplete
                          :items="produtos"
                          label="Produto"
                          :disabled="!novoProduto.tipo"
                          v-model="novoProduto.produto"
                          multiple
                          :rules="[rules.obrigatorio()]"
                          item-value="id"
                          item-text="nome"
                          return-object
                        />
                      </VFlex>
                      <VFlex xs12 sm2 md1>
                        <VTextField
                          label="Quantidade"
                          :disabled="!novoProduto.produto"
                          :rules="[
                            rules.gt(0),
                            rules.quantidadeDecimalPositivo,
                          ]"
                          type="number"
                          min="1"
                          v-model="novoProduto.quantidade"
                        />
                      </VFlex>
                      <VFlex xs12 sm3 md3>
                        <VAutocomplete
                          label="Profissional"
                          v-model="novoProduto.profissional"
                          :items="profissionais"
                          :disabled="somenteLeitura"
                          item-value="id"
                          item-text="nomeFantasia"
                          color="primary"
                          :rules="[rules.obrigatorio()]"
                          @change="atualizarProfissionalProduto"
                          return-object
                        />
                      </VFlex>
                      <VFlex xs12 sm1 md1 text-xs-right text-md-center>
                        <BotaoAdicionarGrid
                          :disabled="!camposPreenchidosProdutos || somenteLeitura"
                          @click="adicionarMultiProduto(novoProduto)"
                        />
                      </VFlex>
                    </VLayout>
                  </VForm>
                  <VLayout>
                    <VFlex md12>
                      <VDataTable
                        hide-actions
                        :headers="cabecalhosGridProdutos"
                        :items="produtosComSubtotais"
                        class="elevation-1"
                      >
                        <template v-slot:items="props">
                          <td>
                            <span>{{ props.item.nome }}</span>
                          </td>
                          <td>
                            <span v-if="somenteLeitura">
                              {{
                                props.item.profissional
                                  ? props.item.profissional.nomeFantasia
                                  : "Sem profissional"
                              }}
                            </span>
                            <VEditDialog
                              v-else
                              :return-value.sync="
                                comanda.produtos[props.index].profissional
                              "
                              lazy
                              large
                              persistent
                              save-text="Atualizar"
                              cancel-text="Cancelar"
                            >
                              {{
                                props.item.profissional
                                  ? props.item.profissional.nomeFantasia
                                  : "Sem profissional"
                              }}
                              <div slot="input">
                                <VSelect
                                  label="Profissional"
                                  v-model="
                                    comanda.produtos[props.index].profissional
                                  "
                                  :items="profissionais"
                                  :disabled="somenteLeitura"
                                  item-value="id"
                                  item-text="nomeFantasia"
                                  color="primary"
                                  :rules="[rules.obrigatorio()]"
                                  return-object
                                />
                              </div>
                            </VEditDialog>
                          </td>
                          <td>
                            <span>
                              {{ formatarDinheiro(props.item.valorBruto) }}
                            </span>
                          </td>
                          <td>
                            <span v-if="somenteLeitura">
                              {{ props.item.quantidade }}
                            </span>
                            <VEditDialog
                              v-else
                              :return-value.sync="comanda.produtos[props.index].quantidade"
                              lazy
                              large
                              save-text="Atualizar"
                              cancel-text="Cancelar"
                            >
                              {{ props.item.quantidade }}
                              <div slot="input" class="mt-3 mb-2">
                                <VTextField
                                  type="number"
                                  min="1"
                                  label="Quantidade"
                                  v-model="comanda.produtos[props.index].quantidade"
                                />
                              </div>
                            </VEditDialog>
                          </td>
                          <td>
                            <span
                              :class="
                                props.item.desconto != null &&
                                props.item.desconto.tipo != 'SemDesconto'
                                  ? 'desconto'
                                  : ''
                              "
                            >
                              {{ formatarDinheiro(props.item.subtotal) }}
                            </span>
                            <span
                              v-if="
                                props.item.desconto != null &&
                                props.item.desconto.tipo != 'SemDesconto'
                                  ? 'desconto'
                                  : ''
                              "
                            >
                              {{
                                formatarDinheiro(
                                  props.item.subtotal -
                                    props.item.desconto.valor
                                )
                              }}
                            </span>
                          </td>
                          <td>
                            <VLayout hidden-print-only>
                              <span />
                              <BotaoExcluir
                                :disabled="somenteLeitura"
                                @click="excluirProduto(props.index)"
                              />
                              <DescontoDialog
                                class="mr-2"
                                :labelTitle="'Desconto unitário - Produto'"
                                :desconto.sync="comanda.desconto"
                                v-on:update:desconto="comanda.desconto = $event"
                                :descontoValorTotal="false"
                                :descontoUnitario="true"
                                :disabledDescontoUnitario="
                                  temDescontoComanda ||
                                  props.item.cortesiaAvulso ||
                                  somenteLeitura
                                "
                                :item="comanda.produtos[props.index]"
                                v-on:update:itemDesconto="
                                  comanda.produtos[props.index].desconto =
                                    $event
                                "
                                :valorTotal="props.item.subtotal"
                                :limiteDesconto="parametros.configuracoesGlobais.utilizaDescontoPorProduto
                                              && comanda.produtos[props.index].permiteDesconto
                                              && comanda.produtos[props.index].percentualMaximoDesconto != null
                                      ? comanda.produtos[props.index].percentualMaximoDesconto
                                      : parametros.configuracoesUsuario.percentualDesconto"
                              >
                              </DescontoDialog>
                            </VLayout>
                          </td>
                        </template>
                      </VDataTable>
                    </VFlex>
                  </VLayout>
                </VCardText>
              </VCard>
            </VExpansionPanelContent>
            <!--Baixa de Insumos-->
            <VExpansionPanelContent v-if="parametros.configuracoesServicos.utilizaBaixaManualEstoque &&
                                          parametros.configuracoesUsuario.permissaoAprovacaoBaixaInsumos">
              <template v-slot:header>
                <span class="title">Baixa de Insumos</span>
              </template>
              <VCard>
                <VCardText>
                  <VForm ref="formInclusaoInsumo" lazy-validation>
                    <VLayout row wrap justify-space-around hidden-print-only>
                      <VFlex xs12 sm2 md2>
                        <VAutocomplete
                          :items="tiposProduto"
                          label="Tipo"
                          v-model="novoInsumo.tipo"
                          item-value="id"
                          item-text="nome"
                          :rules="[rules.obrigatorio()]"
                          return-object
                        />
                      </VFlex>
                      <VFlex xs12 sm3 md4>
                        <VAutocomplete
                          :items="insumos"
                          label="Produto"
                          :disabled="!novoInsumo.tipo"
                          v-model="novoInsumo.produto"
                          multiple
                          :rules="[rules.obrigatorio()]"
                          item-value="id"
                          item-text="nome"
                          return-object
                        />
                      </VFlex>
                      <VFlex xs12 sm2 md1>
                        <VTextField
                          label="Quantidade"
                          :disabled="!novoInsumo.produto"
                          :rules="[
                            rules.gt(0),
                            rules.quantidadeDecimalPositivo,
                          ]"
                          type="number"
                          min="1"
                          v-model="novoInsumo.quantidade"
                        />
                      </VFlex>
                      <VFlex xs12 sm3 md3>
                        <VAutocomplete
                          label="Profissional"
                          v-model="novoInsumo.profissional"
                          :items="profissionais"
                          :disabled="somenteLeitura"
                          item-value="id"
                          item-text="nomeFantasia"
                          color="primary"
                          :rules="[rules.obrigatorio()]"
                          @change="atualizarProfissionalInsumo"
                          return-object
                        />
                      </VFlex>
                      <VFlex xs12 sm1 md1 text-xs-right text-md-center>
                        <BotaoAdicionarGrid
                          :disabled="!camposPreenchidosBaixaInsumos || somenteLeitura"
                          @click="adicionarMultiInsumo(novoInsumo)"
                        />
                      </VFlex>
                    </VLayout>
                  </VForm>
                  <VLayout>
                    <VFlex md12>
                      <VDataTable
                        hide-actions
                        :headers="cabecalhosGridInsumos"
                        :items="insumosComSubtotais"
                        class="elevation-1"
                      >
                        <template v-slot:items="props">
                          <td>
                            <span>{{ props.item.nome }}</span>
                          </td>
                          <td>
                            <span v-if="somenteLeitura">
                              {{
                                props.item.profissional
                                  ? props.item.profissional.nomeFantasia
                                  : "Sem profissional"
                              }}
                            </span>
                            <VEditDialog
                              v-else
                              :return-value.sync="
                                comanda.insumos[props.index].profissional
                              "
                              lazy
                              large
                              persistent
                              save-text="Atualizar"
                              cancel-text="Cancelar"
                            >
                              {{
                                props.item.profissional
                                  ? props.item.profissional.nomeFantasia
                                  : "Sem profissional"
                              }}
                              <div slot="input">
                                <VSelect
                                  label="Profissional"
                                  v-model="
                                    comanda.insumos[props.index].profissional
                                  "
                                  :items="profissionais"
                                  :disabled="somenteLeitura"
                                  item-value="id"
                                  item-text="nomeFantasia"
                                  color="primary"
                                  :rules="[rules.obrigatorio()]"
                                  return-object
                                />
                              </div>
                            </VEditDialog>
                          </td>
                          <td>
                            <span>
                              {{ formatarDinheiro(props.item.valorBruto) }}
                            </span>
                          </td>
                          <td>
                            <span v-if="somenteLeitura || props.item.entregue">
                              {{ props.item.quantidade }}
                              {{ props.item.unidadeControle }}
                            </span>
                            <VEditDialog
                              v-else
                              :return-value.sync="comanda.insumos[props.index].quantidade"
                              lazy
                              large
                              save-text="Atualizar"
                              cancel-text="Cancelar"
                            >
                              {{ props.item.quantidade }}
                              {{ props.item.unidadeControle }}
                              <div slot="input" class="mt-3 mb-2">
                                <VTextField
                                  type="number"
                                  min="1"
                                  label="Quantidade"
                                  v-model="comanda.insumos[props.index].quantidade"
                                />
                              </div>
                            </VEditDialog>
                          </td>
                          <td>
                            <span>
                              {{ formatarDinheiro(props.item.subtotal) }}
                            </span>
                          </td>
                          <td>
                            <VLayout hidden-print-only>
                              <span/>
                              <BotaoExcluir
                                v-if="!props.item.entregue"
                                :disabled="somenteLeitura"
                                @click="excluirInsumo(props.index)"
                              />
                              <VTooltip bottom v-else>
                                <VBtn slot="activator" icon flat small>
                                  <VIcon color="green">check</VIcon>
                                </VBtn>
                                <span>Expedido</span>
                              </VTooltip>
                            </VLayout>
                          </td>
                        </template>
                      </VDataTable>
                    </VFlex>
                  </VLayout>
                </VCardText>
              </VCard>
            </VExpansionPanelContent>
          </VExpansionPanel>
          <VLayout row wrap v-if="valorTotal">
            <VFlex md12>
              <VCard style="margin-top: 0.2%" class="pa-3">
                <VCardTitle class="title">Valores totais</VCardTitle>
                <VCardText>
                  <table border="0">
                    <tbody style="font-size: 15px">
                      <tr>
                        <td style="text-align: right">
                          <strong>Valor total:</strong>
                        </td>
                        <td><strong class="dinheiro">R$</strong></td>
                        <td style="text-align: right">
                          <strong class="dinheiro">
                            {{ formatarDinheiroSemSimbolo(valorTotal) }}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: right">
                          <strong>Cortesia:</strong>
                        </td>
                        <td><strong class="dinheiro">R$</strong></td>
                        <td style="text-align: right">
                          <strong class="dinheiro">
                            {{ formatarDinheiroSemSimbolo(valorTotalCortesia) }}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: right">
                          <strong>Subtotal:</strong>
                        </td>
                        <td><strong class="dinheiro">R$</strong></td>
                        <td style="text-align: right">
                          <strong class="dinheiro">
                            {{
                              formatarDinheiroSemSimbolo(
                                valorTotalMenosCortesia
                              )
                            }}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: right">
                          <strong>Desconto:</strong>
                        </td>
                        <td><strong class="dinheiro">R$</strong></td>
                        <td style="text-align: right">
                          <strong class="dinheiro">
                            {{ formatarDinheiroSemSimbolo(valorDesconto) }}
                          </strong>
                        </td>
                        <td style="text-align: left">
                          <strong style="color: red">{{
                            ajudaDesconto
                          }}</strong>
                        </td>
                      </tr>

                      <tr>
                        <td style="text-align: right">
                          <strong>Valor final:</strong>
                        </td>
                        <td><strong class="dinheiro">R$</strong></td>
                        <td style="text-align: right">
                          <strong class="dinheiro">
                            {{ formatarDinheiroSemSimbolo(valorFinal) }}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </VCardText>
                <VCardActions hidden-print-only>
                  <VLayout row justify-start>
                    <VFlex sm6 xs6 md6>
                      <DescontoDialog
                        class="mr-2"
                        v-if="!!valorTotalMenosCortesia"
                        :desconto.sync="comanda.desconto"
                        v-on:update:desconto="comanda.desconto = $event"
                        :disabled="somenteLeitura || temDescontoUnitarioComanda"
                        :valorTotal="valorTotalMenosCortesia"
                        :limiteDesconto="parametros.configuracoesUsuario.percentualDesconto"
                      >
                      </DescontoDialog>
                      <VBtn
                        v-if="!!valorTotalMenosCortesia"
                        :disabled="
                          somenteLeitura ||
                          (!temDescontoComanda && !temDescontoUnitarioComanda)
                        "
                        @click="removerDeconto()"
                      >
                        Remover desconto
                      </VBtn>
                    </VFlex>
                  </VLayout>
                </VCardActions>
              </VCard>
            </VFlex>
          </VLayout>
          <VLayout row wrap>
            <VFlex md12 style="margin-bottom: 5%; margin-top: 0.2%">
              <VCard>
                <VCardText wrap>
                  <VTextarea
                    label="Observações"
                    v-model="comanda.observacoes"
                    color="primary"
                    :disabled="somenteLeitura"
                  />
                </VCardText>
                <VCardActions>
                  <SituacaoComanda
                    :disabled="somenteLeitura"
                    v-model="situacaoComanda"
                    :situacoes="situacoesParaAlteracao"
                    @update:situacao="atualizarSituacaoEventos"
                  />
                </VCardActions>
              </VCard>
            </VFlex>
          </VLayout>
        </VCardText>
      </VCard>
      <VFooter fixed color="white" style="height: auto">
        <VCard flat tile class="flex">
          <VDivider />
          <VContainer grid-list-md class="py-2" fluid>
            <VLayout wrap hidden-print-only class="d-flex justify-space">

                <VFlex xs4 md1>
                  <VBtn
                    small
                    block
                    outline
                    @click="exibirLogComanda()"
                    :disabled="novoRegistro"
                    style="font-size: 0.8em"
                  >
                    Histórico
                  </VBtn>
                </VFlex>


                <VFlex xs4 offset-md2 md2 class="custom-offset-md1">
                  <VBtn
                    small
                    block
                    outline
                    @click="excluirComanda()"
                    :disabled="bloquearExclusaoComanda"
                    style="font-size: 0.8em"
                  >
                    Excluir / Cancelar
                  </VBtn>
                </VFlex>
                <VFlex xs4 md2>
                  <VBtn
                    :disabled="somenteLeitura || !comanda.eventos.length"
                    small
                    block
                    outline
                    @click="situacaoComanda = true"
                    style="font-size: 0.8em"
                  >
                    Alterar situações
                  </VBtn>
                </VFlex>

                <VFlex xs6 md2>
                  <VBtn
                    :disabled="bloquearSalvamentoComanda"
                    small
                    block
                    class="primary"
                    @click="salvarComanda(true)"
                    style="font-size: 0.8em"
                  >
                    Salvar e finalizar
                  </VBtn>
                </VFlex>

                <VFlex xs6>
                  <VBtn
                    :disabled="bloquearSalvamentoComanda"
                    small
                    block
                    class="primary"
                    @click="salvarComanda()"
                    style="font-size: 0.8em"
                  >
                    Salvar
                  </VBtn>
                </VFlex>

                <VFlex xs6 md3 style="display: flex;" v-if="mostrarBotaoAtendimentoViaProntuario">
                  <VBtn
                    :disabled="bloquearAtendimentoViaProntuario"
                    small
                    block
                    @click="iniciarAtendimentoProntuario"
                    style="font-size: 0.8em; background-color: #00872F; color: white;"
                    class="custom-container"
                  >
                    <span style="flex: 1;">Iniciar atendimento via prontuário</span>
                    <VIcon class="ml-2 icon-input">input</VIcon>
                  </VBtn>
                </VFlex>
            </VLayout>
          </VContainer>
        </VCard>
      </VFooter>
    </VCard>
    <Signatarios
      docType="Ficha"
      :visible="telaSignatarios"
      :item="itemSelecionado"
      @close="abrir"
    />
    <VDialog v-model="servicoContratadoDialog" max-width="1000px" persistent>
      <VCard>
        <VToolbar dark color="primary">
          Ficha de acompanhamento
          <VSpacer></VSpacer>
          <VToolbarItems>
            <VBtn icon dark @click="servicoContratadoDialog = false">
              <VIcon>close</VIcon>
            </VBtn>
          </VToolbarItems>
        </VToolbar>
        <VCardText>
          <ServicosContratados
            :idCliente="comanda.cliente.id"
          ></ServicosContratados>
        </VCardText>
        <VCardActions class="bottom">
          <VSpacer></VSpacer>
          <VBtn color="primary" flat @click="servicoContratadoDialog = false"
            >Fechar</VBtn
          >
        </VCardActions>
      </VCard>
    </VDialog>
    <VDialog v-model="impressaoMultiplaDialog" max-width="1000px" persistent>
      <VCard>
        <VToolbar dark color="primary">
          Impressão múltipla
          <VSpacer></VSpacer>
          <VToolbarItems>
            <VBtn icon dark @click="impressaoMultiplaDialog = false">
              <VIcon>close</VIcon>
            </VBtn>
          </VToolbarItems>
        </VToolbar>
        <VCardText>
          <VCardTitle class="subheading">
            A comanda atual possui múltiplos profissionais envolvidos, deseja
            imprimir uma única comanda, ou uma comanda para cada profissional?
          </VCardTitle>
          <VRadioGroup v-model="impressaoMultiplaRB" @change="fator = 0">
            <VLayout>
              <VFlex>
                <VRadio
                  id="ImpressaoUnica"
                  label="Impressão Única"
                  value="ImpressaoUnica"
                />
              </VFlex>
              <VFlex>
                <VRadio
                  id="ImpressaoMultipla"
                  label="Impressão Múltipla"
                  value="ImpressaoMultipla"
                />
              </VFlex>
            </VLayout>
          </VRadioGroup>
        </VCardText>
        <VCardActions class="bottom">
          <VSpacer></VSpacer>
          <VBtn color="primary" flat @click="imprimir(impressaoMultiplaRB)"
            >Imprimir</VBtn
          >
          <VBtn color="primary" flat @click="impressaoMultiplaDialog = false"
            >Fechar</VBtn
          >
        </VCardActions>
      </VCard>
    </VDialog>
    <table
      id="printer-ticket"
      style="max-width: 255px"
      class="d-none d-print-block"
    >
      <thead>
        <tr>
          <th colspan="3">{{ this.parametros.franquia.nome }}</th>
        </tr>
        <tr>
          <th colspan="3">
            {{ this.parametros.franquia.logradouro }},
            {{ this.parametros.franquia.numero }}<br />
            {{ this.parametros.franquia.bairro }} -
            {{ this.parametros.franquia.cidade }} -
            {{ this.parametros.franquia.uf }} -
            {{ this.parametros.franquia.cep }}
          </th>
        </tr>
        <tr>
          <th colspan="3">CNPJ: {{ this.parametros.franquia.cnpj }}</th>
        </tr>
        <th colspan="3">----------------------------------------------</th>
      </thead>
      <tbody>
        <tr>
          <th colspan="3">{{ new Date().toLocaleString() }}</th>
        </tr>
        <tr>
          <th colspan="3">
            <b>Comanda de serviço</b>
          </th>
        </tr>
        <tr>
          <th colspan="3">
            <b>Usuário:</b> {{ this.parametros.informacoesUsuario.login }} <br />
          </th>
        </tr>
        <tr>
          <td colspan="3"><b>Nº da comanda:</b> {{ this.comanda.id }}</td>
        </tr>
        <tr>
          <td colspan="3">
            <b>Nome do cliente:</b> {{ this.comanda.cliente.nome }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="3">
            <b>------------------Serviços------------------</b>
          </th>
        </tr>
        <tr colspan="3">
          <th>Cód.</th>
          <th>Serviço</th>
          <th>Pacote</th>
        </tr>
        <tr
          colspan="3"
          v-for="(evento, index) in this.comanda.eventos"
          :key="evento.id"
        >
          <td align="center">{{ index + 1 }}</td>
          <td align="left" style="max-width: 100px">
            {{ evento.servico.nome }}<br />
            Profissional: {{ evento.profissionais.responsavel.nomeFantasia
            }}<br />
            {{ new Date(evento.hora).toLocaleTimeString() }}
          </td>
          <td align="center">{{ evento.servico.utilizacaoPacote }}</td>
        </tr>
      </tfoot>
      <br />
      <br />
      <br />
    </table>

    <div id="impressao-termica" class="d-none d-print-block" style="max-width: 350px">
			<br />
				<div>
					<span style="margin-left: 90px;">RESUMO AGENDAMENTO</span>
					<br />
          <br />
					<span>Cliente: {{ this.comanda.cliente.nome }} </span>
					<br />
					<span>Telefone: {{ this.comanda.cliente.telefone ? this.comanda.cliente.telefone : this.comanda.cliente.telefoneCelular }}</span>
					<br />
				</div>
        <br />
  <hr />
  <hr />
        <br />
				<span style="margin: 0px 0px 50px 130px">SERVIÇOS</span>
        <br />
        <br />
				<table>
					<thead>
						<tr>
              <th style="text-align:left">Pacote</th>
							<th style="text-align:left">Serviço</th>
							<th style="text-align:left">Prof.</th>
							<th style="text-align:left">Data</th>
              <th style="text-align:left">Hora</th>
              <th style="text-align:left">Valor</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(evento, index) in this.comanda.eventos" :key="index">
							<td>{{ evento.servico.utilizacaoPacote ? evento.servico.utilizacaoPacote : "Avulso" }}</td>
							<td>{{ evento.servico.nome }}</td>
							<td>{{ evento.profissionais.responsavel.nomeFantasia }}</td>
              <td>{{ evento.data ? formatarData(evento.data) : formatarData(evento.hora) }}</td>
              <td>{{ verificarEformatarHora(evento.hora) }}</td>
              <td>{{ parseFloat(evento.valorBruto - (evento.desconto ? evento.desconto.valor : 0)).toFixed(2)}}</td>
						</tr>
					</tbody>
				</table>
		</div>
  </VDialog>
</template>

<script>
import cake from "@/assets/img/cake.png";
import whatsapp from "@/assets/img/whatsapp.png";
import alerts from "@/common/alerts";
import ApiService from "@/common/api.service";
import { default as erpWebApiService, default as erpWebAppService } from "@/common/erpWebAppService";
import eventos from "@/common/eventos";
import forms from "@/common/forms";
import DescontoDialog from "@/components/Dialog/DescontoDialog";
import LoadingDialog from "@/components/Dialog/Loading";
import FormRenderDialog from "@/components/Formularios/FormRenderDialog";
import datas from "@/mixins/datas";
import numeros from "@/mixins/numeros";
import timeOperations from "@/mixins/timeOperations";
import apiConfig from "@/services/apiConfig";
import moment from "moment";
import { mapState } from "vuex";
import AutocompleteCliente from "../AutocompleteCliente";
import BotaoAdicionarGrid from "../Botoes/BotaoAdicionarGrid";
import BotaoExcluir from "../Botoes/BotaoExcluir";
import ServicosContratados from "../EvolucaoTratamento/ServicosContratados";
import SelecaoData from "../SelecaoData";
import LogComandas from "./LogComandas";
import SelectProfissionais from "./SelectProfissionais";
import Signatarios from "./Signatarios.vue";
import SituacaoComanda from "./SituacaoComanda";
import ScarfClientService from "@/common/scarf.service.js";
import biometriaApiService from "@/common/biometriaApiService.js";

export default {
  mixins: [numeros, datas, timeOperations],
  created() {
    eventos.barramento.$on(eventos.ABRIR_DIALOG_COMANDA, this.abrir);
    this.situacoes =
      this.parametros.permissoes.permissoesComanda.finalizarComandas == "N"
        ? ["Agendado", "Confirmado", "Presente"]
        : ["Agendado", "Confirmado", "Executado", "Faltou", "Presente"];
  },
  data() {
    return {
      bloquearAtendimentoViaProntuario: true,
      mostrarBotaoAtendimentoViaProntuario: false,
      faltou: {
        carregando: [],
        adicionando: [],
      },
      statusEnviado: false,
      servicoAlterado: "",
      horaServicoAlterado: "",
      novaSituacao: "",
      situacaoAtual: "",
      servicoContratadoDialog: false,
      itemSelecionado: {},
      telaSignatarios: false,
      descontoUnitario: false,
      descontoUnitarioProduto: false,
      situacaoComanda: false,
      logComandas: false,
      profissionaisEventoIndice: -1,
      profissionaisEvento: {
        responsavel: {
          id: "",
          nomeFantasia: "Sem profissional",
          preferencial: false,
        },
        auxiliares: [],
      },
      visibilidadePaineis: [true, false, false],
      rules: forms.rules,
      requisicaoEmAndamento: false,
      semPermissaoAlterarCriarComandas: false,
      aberto: false,
      comanda: {
        cliente: {
          id: null,
          aniversariante: 0,
          observacao: "",
        },
        data: null,
        eventos: [],
        produtos: [],
        equipamentos: [],
        insumos: [],
        desconto: {
          tipo: "SemDesconto",
          valor: 0,
        },
      },
      sugestoes: {
        idProfissional: null,
        idEspaco: null,
        horario: null,
      },
      novoInsumo: {
        tipo: null,
        produto: null,
        quantidade: null,
        profissional: null,
        unidadeControle: null,
      },
      novoProduto: {
        tipo: null,
        produto: null,
        quantidade: null,
        profissional: null,
      },
      novoEquipamento: {
        tipo: null,
        equipamento: null
      },
      novoEvento: {
        idLock: 0,
        temDesconto: false,
        servicoAvulso: false,
        cortesiaAvulso: false,
        avaliacao: false,
        tipoServico: null,
        servico: null,
        espaco: null,
        profissional: {
          id: null,
          nomeFantasia: "Sem profissional",
        },
        profissionalPreferencial: false,
        duracao: null,
        horario: null,
        situacao: "Agendado",
        aplicandoDesconto: false,
      },
      tiposProduto: [],
      tiposServico: [],
      tiposEquipamentos: [],
      insumos: [],
      produtos: [],
      equipamentos: [],
      espacos: [],
      profissionaisBackend: [],
      fecharComanda: false,
      horarios: [],
      situacoes: ["Agendado", "Confirmado", "Executado", "Faltou", "Presente"],
      cabecalhosGridInsumos: [
        {
          text: "Nome",
          value: "insumo.nome",
          sortable: false,
        },
        {
          text: "Profissional",
          value: "insumo.profissional",
          sortable: false,
        },
        {
          text: "Valor unitário",
          value: "insumo.preco",
          sortable: false,
        },
        {
          text: "Quantidade",
          value: "quantidade",
          sortable: false,
        },
        {
          text: "Subtotal",
          value: "subtotal",
          sortable: false,
        },
        {
          text: "Ações",
          value: "insumo.id",
          sortable: false,
        },
      ],
      cabecalhosGridProdutos: [
        {
          text: "Nome",
          value: "produto.nome",
          sortable: false,
        },
        {
          text: "Profissional",
          value: "produto.profissional",
          sortable: false,
        },
        {
          text: "Valor unitário",
          value: "produto.preco",
          sortable: false,
        },
        {
          text: "Quantidade",
          value: "quantidade",
          sortable: false,
        },
        {
          text: "Subtotal",
          value: "subtotal",
          sortable: false,
        },
        {
          text: "Ações",
          value: "produto.id",
          sortable: false,
        },
      ],
      cabecalhosGridEquipamento: [
        {
          text: "Descrição",
          value: "equipamento.descricao",
          sortable: false,
        },
        {
          text: "Ações",
          value: "equipamento.id",
          sortable: false,
        },
      ],
      cabecalhosGridServicos: [
        {
          text: "Pacote",
          value: "pacote",
          sortable: false,
        },
        {
          text: "Serviço",
          value: "servico",
          sortable: false,
        },
        {
          text: "Espaço",
          value: "espaco",
          sortable: false,
        },
        {
          text: "Profissionais",
          value: "profissional",
          sortable: false,
        },
        {
          text: "Duração",
          value: "duracao",
          sortable: false,
        },
        {
          text: "Horário",
          value: "horario",
          sortable: false,
        },
        {
          text: "Situação",
          value: "situacao",
          sortable: false,
        },
        {
          text: "Preferencial",
          value: "profissional.preferencial",
          sortable: false,
        },
        {
          text: "Valor Bruto",
          value: "valorBruto",
          sortable: false,
        },
        {
          text: "Acões",
          sortable: false,
        },
      ],
      servicosAvulsos: [],
      servicosAdquiridos: [],
      mascaraDuracao: "##:##",
      itemEditado: {
        espaco: {
          id: 0,
          nome: "",
        },
        duracao: 0,
        hora: 0,
        servico: {},
      },
      impressaoMultiplaDialog: false,
      impressaoMultiplaRB: "ImpressaoUnica",
      profissionaisUnicos: [],
      urlVendaFacil: {
        preVenda: `${apiConfig.getUrlVendaFacil()}/AutenticacaoPorToken?appName=LinxMicrovixERP&authToken=${apiConfig.getTokenLogin()}&rotinaOrigem=EntregaFutura`,
      },
      conteudo:"",
      idComanda: null
    };
  },

  computed: {
    ...mapState(["parametros"]),
    excluirDocumentosDeAssinatura() {
      let possuiChave = false;
      if (this.novoRegistro) {
        this.comanda.eventos.forEach((item) => {
          if (item.chave !== null && item.chave !== "") {
            possuiChave = true;
          }
        });
      }
      return this.novoRegistro && possuiChave;
    },
    temDescontoComanda() {
      return this.comanda.desconto != null &&
        this.comanda.desconto.tipo != "SemDesconto"
        ? true
        : false;
    },
    temDescontoUnitarioComanda() {
      return (
        this.comanda.produtos.filter(
          (p) => p.desconto != null && p.desconto.tipo != "SemDesconto"
        ).length > 0 ||
        this.comanda.eventos.filter(
          (p) => p.desconto != null && p.desconto.tipo != "SemDesconto"
        ).length > 0
      );
    },
    situacoesParaAlteracao() {
      return this.situacoes.filter(
        (s) =>
          s !== "Executado" || this.parametros.alterarAgendamentosExecutados
      );
    },
    profissionais() {
      return [
        { id: null, nomeFantasia: "Sem profissional" },
        ...this.profissionaisBackend,
      ];
    },
    produtosComSubtotais() {
      return this.comanda.produtos.map((p) => ({
        ...p,
        subtotal: p.quantidade * p.valorBruto,
      }));
    },
    insumosComSubtotais() {
      return this.comanda.insumos.map((p) => ({
        ...p,
        subtotal: p.quantidade * p.valorBruto,
      }));
    },
    somenteLeitura() {
      return (
        this.comanda.fechada ||
        this.requisicaoEmAndamento ||
        this.semPermissaoAlterarCriarComandas
      );
    },
    camposPreenchidosProdutos() {
      return (
        this.novoProduto.tipo &&
        this.novoProduto.produto &&
        (this.novoProduto.quantidade && this.novoProduto.quantidade > 0) &&
        this.novoProduto.profissional
      );
    },
    camposPreenchidosBaixaInsumos() {
      return (
        this.novoInsumo.tipo &&
        this.novoInsumo.produto &&
        (this.novoInsumo.quantidade && this.novoInsumo.quantidade > 0) &&
        this.novoInsumo.profissional
      );
    },
    telefone() {
      if (this.comanda.cliente && this.comanda.cliente.telefone)
        return `(${this.comanda.cliente.telefone.area}) ${this.comanda.cliente.telefone.numero}`;
      else return null;
    },
    novoRegistro() {
      return !this.comanda.id;
    },
    titulo() {
      if (!this.novoRegistro) {
        return `${
          this.parametros.numeracaoDaComandaManual &&
          (this.comandaComStatusPresenteOuExecutado ||
            (this.comanda.idNumeroManual != null &&
              this.comanda.idNumeroManual != this.comanda.id))
            ? ""
            : this.comanda.id
        } - ${this.comanda.cliente.nome} - ${moment(this.comanda.data).format(
          "L"
        )}${this.comanda.fechada ? " (Fechada)" : ""}`;
      }
      return "Novo agendamento";
    },
    ajudaDesconto() {
      let tipo = null;

      if (this.temDescontoComanda) {
        switch (this.comanda.desconto.tipo) {
          case "Final":
            tipo = `(desconto por valor final)`;
            break;
          case "Valor":
            tipo = `(desconto por valor)`;
            break;
          case "Percentual":
            tipo = `(-${this.formatarPorcentagem(
              this.comanda.desconto.valor
            )})`;
            break;
          default:
            tipo = null;
        }
      }

      return this.temDescontoUnitarioComanda ? `(desconto unitário)` : tipo;
    },
    bloquearExclusaoComanda() {
      return (
        this.requisicaoEmAndamento ||
        this.novoRegistro ||
        this.comanda.fechada ||
        this.somenteLeitura ||
        !!this.comanda.eventos.find((e) => {
          if (this.bloquearEdicaoEvento(e)) {
            return true;
          }
        })
      );
    },
    comandaComStatusPresenteOuExecutado() {
      if (
        !this.comanda.fechada &&
        (this.comanda.eventos.filter((e) => e.situacao == "Executado").length >
          0 ||
          this.comanda.eventos.filter((e) => e.situacao == "Presente").length >
            0)
      ) {
        return true;
      }
      return false;
    },
    excluirBloqueadoPorParametro() {
      if (this.parametros.bloquearExclusaoComandaAberta)
        return this.comandaComStatusPresenteOuExecutado;
      return false;
    },
    bloquearSalvamentoComanda() {
      return (
        this.requisicaoEmAndamento ||
        this.comanda.fechada ||
        this.somenteLeitura ||
        !this.comanda.cliente.id ||
        (!this.comanda.eventos.length && !this.comanda.produtos.length)
      );
    },
    clienteSelecionado() {
      return !!this.comanda.cliente.id;
    },
    valorDesconto() {
      let descontoUnitarioProduto = this.verificarDescontoAvulso(
        this.comanda.produtos
      );
      let descontoUnitarioServico = this.verificarDescontoAvulso(
        this.comanda.eventos
      );

      if (descontoUnitarioProduto + descontoUnitarioServico > 0)
        return descontoUnitarioProduto + descontoUnitarioServico;
      else return this.valorTotalMenosCortesia - this.valorFinal; //Original
    },
    valorTotalCortesia() {
      return this.comanda.eventos
        .filter((e) => e.cortesiaAvulso)
        .reduce((total, e) => total + e.valorBruto, 0);
    },
    valorTotalMenosCortesia() {
      return this.valorTotal - this.valorTotalCortesia;
    },
    valorFinal() {
      let descontoUnitarioProduto = this.verificarDescontoAvulso(
        this.comanda.produtos
      );
      let descontoUnitarioServico = this.verificarDescontoAvulso(
        this.comanda.eventos
      );

      if (descontoUnitarioProduto + descontoUnitarioServico > 0) {
        return (
          this.valorTotalMenosCortesia -
          (descontoUnitarioProduto + descontoUnitarioServico)
        );
      } else {
        var desconto = this.comanda.desconto;
        if (!desconto) return this.valorTotalMenosCortesia;

        switch (desconto.tipo) {
          case "Final":
            return desconto.valor;
          case "Percentual":
            return this.valorTotalMenosCortesia * (1.0 - desconto.valor);
          case "Valor":
            return this.valorTotalMenosCortesia - desconto.valor;
        }
        return this.valorTotalMenosCortesia;
      }
    },
    valorTotal() {
      return (
        this.comanda.eventos.reduce((total, e) => total + e.valorBruto, 0) +
        this.produtosComSubtotais.reduce((total, p) => total + p.subtotal, 0)
      );
    },
    parametros() {
      return this.$store.state.parametros;
    },
    retornaServicos() {
      return this.novoEvento.servicoAvulso
        ? this.servicosAvulsos
        : this.servicosAdquiridos;
    },
    retornaTipoServicos() {
      if (
        this.novoEvento.profissional.nomeFantasia == "Sem profissional" ||
        !this.parametros.configuracoesServicos.restringeServicosPorProfissional
      )
        return this.tiposServico;
      else
        return this.tiposServico.filter(
          (s) => s.idProfissional === this.novoEvento.profissional.id
        );
    },
    retornaProfissionais() {
      if (
        !this.parametros.configuracoesServicos.restringeServicosPorProfissional
      )
        return this.profissionais;
      else if (
        this.novoEvento.tipoServico != null &&
        (this.novoEvento.servico == null || this.novoEvento.servico.length == 0)
      )
        return this.profissionais.filter(
          (s) => s.idTipoServico === this.novoEvento.tipoServico.id
        );
      else return this.retornaProfissionaisValidosParaOServico();
    },
  },

  watch: {
    idComanda: function () {
      this.verificarAcessoAtendimentoProntuario();
    },
    fecharComanda(fechaComanda) {
      if (fechaComanda) {
        this.fechar(true);
        this.fecharComanda = false;
      }
    },
    "comanda.cliente": async function () {
      this.retornaServicosAdquiridos();
    },
    "novoEvento.profissional": async function () {
      this.retornaServicosAdquiridos();
      if (this.novoEvento.tipoServico != null)
        this.carregarServicosAvulsosPorTipo(this.novoEvento.tipoServico);
    },
    "comanda.data": function (nova, antiga) {
      if (nova !== antiga) this.verificarComandaAberta();
      this.carregaHorarios();
    },
    "novoProduto.tipo": async function (tipoProduto) {
      if (tipoProduto) {
        this.novoProduto.produto = null;
        this.novoProduto.quantidade = null;
        this.produtos = [];
        this.produtos = (await ApiService.get(`produtos/${tipoProduto.id}`)).data;
      }
    },
    "novoEquipamento.tipo": async function (tipoEquipamento) {
      if (tipoEquipamento) {
        this.novoEquipamento.equipamento = null;
        this.equipamentos = [];
        this.equipamentos = (await ApiService.get(`equipamentos/${tipoEquipamento.id}`)).data;

      }
    },
    "novoInsumo.tipo": async function (tipoInsumo) {
      if (tipoInsumo) {
        this.novoInsumo.produto = null;
        this.novoInsumo.quantidade = null;
        this.insumos = [];
        this.insumos = (await ApiService.get(`produtos/${tipoInsumo.id}`)).data;

      }
    },
    "novoProduto.produto": async function (produto) {
      if (produto && !this.novoProduto.quantidade)
        this.novoProduto.quantidade = 1;
      if (produto != null && produto.length < 1)
        this.novoProduto.produto = null;

    },
    "novoInsumo.produto": async function (insumo) {
      if (insumo && !this.novoInsumo.quantidade)
        this.novoInsumo.quantidade = 1;
      if (insumo.length < 1)
        this.novoInsumo.produto = null;
    },
    async visibilidadePaineis(paineis) {
      if (this.tiposProduto.length < 1 && (paineis[1] || paineis[2]))
        this.tiposProduto = (await ApiService.get("tiposProduto")).data;

    },
    valorDesconto(valor) {
      if (valor <= 0) this.comanda.desconto = null;
    },
    valorFinal(valor) {
      if (valor < 0) this.comanda.desconto = null;
    },
    "novoEvento.servicoAvulso": function () {
      this.novoEvento.tipoServico = null;
      this.novoEvento.servico = null;
    },
    "novoEvento.servico": function (servico) {
      this.novoEvento.duracao =
        servico != null && servico[0] != undefined && servico[0].duracao != null
          ? this.converterMinutosEmHora(servico[0].duracao)
          : "";
    },
    "novoEvento.tipoServico": function (tipo) {
      this.novoEvento.servico = null;
      this.carregarServicosAvulsosPorTipo(tipo);
    },
    "comanda.eventos": function (eventos) {
      for (let e of eventos) {
        if (!e.profissional) {
          e.profissional = {
            id: null,
            nomeFantasia: "Sem profissional",
          };
        }
      }
    },
    profissionais() {
      this.sugerirProfissional();
    },
    espacos() {
      this.sugerirEspaco();
    },
  },
  components: {
    SelectProfissionais,
    SelecaoData,
    AutocompleteCliente,
    BotaoAdicionarGrid,
    BotaoExcluir,
    FormRenderDialog,
    LoadingDialog,
    DescontoDialog,
    LogComandas,
    SituacaoComanda,
    ServicosContratados,
    Signatarios,
  },
  async mounted() {
    this.mostrarBotaoAtendimentoViaProntuario = this.parametros.configuracoes.atendimentoProntuario;

    this.$refs.formInclusaoEvento.resetValidation();
    this.$refs.formInclusaoProduto.resetValidation();
    if (this.$refs["formInclusaoInsumo"])
      this.$refs.formInclusaoInsumo.resetValidation();
  },
  methods: {
    verificarAcessoAtendimentoProntuario() {
      let comandaPossuiFicha = null;
      let idFormularioPreenchido = null;
      let fichaObrigatoria = null;

      if (this.comanda && this.comanda.eventos && this.comanda.eventos.length > 0) {
        comandaPossuiFicha = this.comanda.eventos[0].servico.formulario != null;
        idFormularioPreenchido = this.comanda.eventos[0].idFormularioPreenchido;
        fichaObrigatoria = this.comanda.eventos[0].servico.formulario ? this.comanda.eventos[0].servico.formulario.obrigatorio : false
      }

      if (this.idComanda === null || this.comanda.fechada) {
        this.bloquearAtendimentoViaProntuario = true;
      } else if (comandaPossuiFicha && !idFormularioPreenchido && fichaObrigatoria) {
        this.bloquearAtendimentoViaProntuario = true;
      } else {
        this.bloquearAtendimentoViaProntuario = false;
      }
    },
    carregaObservacaoCliente() {
      if (
        this.novoRegistro &&
        this.comanda.cliente &&
        this.comanda.cliente.id
      ) {
        this.comanda.observacoes = this.comanda.cliente.observacao;
      }
    },
    alterando(nova) {
      let antiga = this.comanda.data;
      if (this.comanda.eventos.length > 0)
        this.consultarLockEventos(antiga, nova);
    },
    habilitaAssinatura(evento) {
      return evento.chave != null && evento.chave !== "";
    },
    async carregarTiposEquipamentos(){
      this.tiposEquipamentos = (await ApiService.get('equipamentos/tipos')).data;
    },
    removerDeconto() {
      this.descontoUnitario = false;
      this.descontoUnitarioProduto = false;
      this.comanda.desconto = {
        tipo: "SemDesconto",
        valor: 0,
      };
      this.comanda.eventos.map((e) => {
        e.desconto = {
          tipo: "SemDesconto",
          valor: 0,
        };
      });
      this.comanda.produtos.map((p) => {
        p.desconto = {
          tipo: "SemDesconto",
          valor: 0,
        };
      });
    },
    corStatusAssinatura(item) {
      let status = item.statusDocumento != null ? item.statusDocumento : "";
      return status === "Finalizado" ? "green" : "red";
    },
    async mostrarDialogSignatarios(item) {
      this.itemSelecionado = item;
      this.telaSignatarios = true;
    },
    eventoNumerico(event) {
      var invalids = ["-", "+", "e", "E", ",", "."];
      if (invalids.includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    verificarDescontoAvulso(listaItem) {
      let desconto = 0;

      if (
        Array.isArray(listaItem) ||
        listaItem != null ||
        listaItem != undefined
      ) {
        for (var index = 0; index < listaItem.length; index++)
          desconto +=
            listaItem[index].desconto != null
              ? listaItem[index].desconto.valor
              : 0;
      }

      return desconto;
    },
    somarDesconto() {
      var calcularDesconto = 0;
      if (this.temDescontoUnitarioComanda) {
        if (
          this.comanda.produtos.filter(
            (p) => p.desconto != null && p.desconto.tipo != "SemDesconto"
          ).length > 0
        ) {
          this.comanda.produtos.map((p) => {
            if (p.desconto) {
              calcularDesconto += p.desconto.valor;
            }
            return p;
          });
        }

        if (
          this.comanda.eventos.filter(
            (p) => p.desconto != null && p.desconto.tipo != "SemDesconto"
          ).length > 0
        ) {
          this.comanda.eventos.map((p) => {
            if (p.desconto) {
              calcularDesconto += p.desconto.valor;
            }
            return p;
          });
        }
      }
      return calcularDesconto;
    },
    impressaoTermica() {
      this.conteudo = document.getElementById("impressao-termica").outerHTML;
      this.imprimir();
    },
    abrirDialogPrint() {
      var profissionais = [];
      if (
        this.parametros.configuracoesServicos
          .utilizaImpressoraNaoFiscalParaImpressaoDeComandas == true
      ) {
        this.comanda.eventos.forEach((evento) => {
          profissionais.push(evento.profissionais.responsavel);
          evento.profissionais.auxiliares.forEach((auxiliar) => {
            profissionais.push(auxiliar);
          });
        });
        this.profissionaisUnicos = profissionais.filter(
          (v, i, a) => a.findIndex((t) => t.id === v.id) === i
        );
        if (this.profissionaisUnicos.length > 1)
          this.impressaoMultiplaDialog = true;
        else this.imprimir("ImpressaoUnica");
      } else {
        print({
          printable: "xxformRenderContainer",
          type: "qqhtml",
          scanStyles: true,
          targetStyles: "",
        });
      }
    },
    imprimir(opcaoImpressao) {
      var winPrint = window.open(
        "",
        "",
        "left=0,top=0,width=1024,height=768,toolbar=0,scrollbars=0,status=0"
      );

      if (opcaoImpressao == "ImpressaoMultipla") {
        for (var i = 0; i < this.profissionaisUnicos.length; i++) {
          this.conteudo += this.montarImpressao();
        }
      } else if (opcaoImpressao == "ImpressaoUnica")
        this.conteudo += this.montarImpressao();

      winPrint.document.write(this.conteudo);
      winPrint.document.close();
      winPrint.focus();
      winPrint.print();
      winPrint.close();
    },
    montarImpressao() {
      this.conteudo = document.getElementById("printer-ticket").outerHTML;
      return this.conteudo;
    },
    consultaStatusPresenteExecutado() {
      let response = false;
      if (
        this.comanda.eventos.filter((e) => e.situacao == "Presente").length >
          0 ||
        this.comanda.eventos.filter((e) => e.situacao == "Executado").length > 0
      )
        response = true;
      return response;
    },
    async retornaServicosAdquiridos() {
      if (this.comanda.cliente && this.comanda.cliente.id) {
        if (
          !this.parametros.configuracoesServicos
            .restringeServicosPorProfissional
        )
          this.servicosAdquiridos = (
            await ApiService.get(`servicos/cliente/${this.comanda.cliente.id}`)
          ).data;
        else
          this.servicosAdquiridos = (
            await ApiService.get(
              `servicos/clienteEProfissional/${this.comanda.cliente.id}/${
                this.novoEvento.profissional.id != null
                  ? this.novoEvento.profissional.id
                  : 0
              }`
            )
          ).data;
      } else this.servicosAdquiridos = [];
    },
    async getClienteNovo(id) {
      var retorno = await ApiService.get(`clientes/getClienteNovo/${id}`);
      return retorno.data;
    },
    atualizarSituacaoEventos(situacao) {
      this.comanda.eventos
        .filter((e) => e.situacao !== "Executado")
        .forEach((e) => (e.situacao = situacao));

      if (
        this.parametros.configuracoes.permissaoEnvioNotificacaoWhatsApp &&
        this.parametros.configuracoes.mensagemCompartilhamentoStatusAgenda !=
          null
      )
        this.exibirCompartilhamentoWeb(true, false);
    },
    atualizarProfissionalProduto(profissional) {
      this.novoProduto.profissional = Object.assign({}, profissional);
    },
    atualizarProfissionalInsumo(profissional) {
      this.novoInsumo.profissional = Object.assign({}, profissional);
    },
    alternarCortesia(indice, evento) {
      evento.cortesiaAvulso = !evento.cortesiaAvulso;
      evento.desconto = {
        tipo: "SemDesconto",
        valor: 0,
      };
      this.$set(this.comanda.eventos, indice, evento);
    },
    isProfissionalNulo(profissional) {
      return (
        profissional.responsavel === null ||
        profissional.responsavel.id === null
      );
    },
    isSituacaoExecutado(situacao) {
      return situacao === "Executado";
    },
    inicializarHelperProfissionais(evento) {
      this.profissionaisEventoIndice = this.comanda.eventos.indexOf(evento);
      this.profissionaisEvento = Object.assign({}, evento.profissionais);
    },
    cancelarEditDialogSituacao(indice) {
      this.$refs[`dialogSituacao${indice}`].cancel();
      this.close();
    },
    salvarSituacao(indice, item) {
      this.servicoAlterado = item.servico.nome;
      this.horaServicoAlterado = moment(item.hora).format("HH:mm");
      this.novaSituacao = item.situacao;
      this.atualizarStatusPresente(item.situacao);
      this.$refs[`dialogSituacao${indice}`].save(
        this.$refs[`dialogSituacao${indice}`].returnValue
      );

      if (this.isSituacaoExecutado(item.situacao))
        this.salvarProfissionaisDialog(item);

      if (
        this.parametros.configuracoes.permissaoEnvioNotificacaoWhatsApp &&
        this.parametros.configuracoes.mensagemCompartilhamentoStatusAgenda !=
          null &&
        this.parametros.configuracoes.mensagemCompartilhamentoStatusAgenda != ""
      )
        this.exibirCompartilhamentoWeb(true, true);
    },
    atualizarStatusPresente(situacao) {
      if (situacao === "Presente")
        this.atualizarSituacaoEventosAgendadoOuConfirmado(situacao);
    },
    atualizarSituacaoEventosAgendadoOuConfirmado(situacao) {
      this.comanda.eventos.filter((evt) => {
        if (evt.situacao === "Agendado" || evt.situacao === "Confirmado")
          evt.situacao = situacao;
      });
    },
    async inicializarHelperDuracao(item) {
      this.itemEditado.duracao = this.converterMinutosEmHora(item.duracao);
    },
    async salvarDuracaoDialog(item) {
      let eventoEmUso = await this.isEventoEmUso(
        item.hora,
        this.converterFormatoHoraMinutoEmMinutos(this.itemEditado.duracao),
        item.profissionais.responsavel.id,
        item.espaco.id,
        this.comanda.data
      );

      if (!eventoEmUso) {
        item.duracao = this.converterFormatoHoraMinutoEmMinutos(
          this.itemEditado.duracao
        );
        item.data = this.comanda.data;
        await this.upsertLockEvento(item, true);
      }
    },
    obterDescricaoStatusEquipamento(status) {
      switch (status) {
          case 1:
            return 'Ativo';
          case 2:
            return 'Inativo';
          case 3:
            return 'Em Manutenção';
          default:
            return 'Sem Status';
        }
    },
    obterClasseStatusEquipamento(status) {
      switch (status) {
          case 1:
            return 'status-ativo';
          case 2:
            return 'status-inativo';
          case 3:
            return 'status-manutencao';
          default:
            return '';
        }
    },
    async consultarLockEventos(dataAntiga, nova) {
      await this.$refs.janelaCarregando.abrir();

      let espacoOcupado = true;
      let profissionalOcupado = true;
      let html = "";
      let body = "";
      let inicio =
        "<table id='table' class='v-table theme--light'>" +
        "        <thead>" +
        "            <tr>" +
        "                <th>Data</th>" +
        "                <th>Serviço</th>" +
        "                <th>Espaço</th>" +
        "                <th>Hora</th>" +
        "                <th>Duração</th>" +
        "                <th>Profissional</th>" +
        "            </tr>" +
        "        </thead>" +
        "        <tbody>";
      let final = "</tbody>" + "</table>";

      let existeEventoIndisponivel = false;
      let listaEventos = [];

      for (let evt of this.comanda.eventos) {
        espacoOcupado = await this.isEspacoOcupado(
          evt.hora,
          evt.duracao,
          evt.espaco.id,
          nova,
          false
        );
        profissionalOcupado = await this.isProfissionalOcupado(
          evt.hora,
          evt.duracao,
          evt.profissionais.responsavel.id,
          nova,
          false
        );

        if (espacoOcupado || profissionalOcupado) {
          let estilo = "style='color:red;font-weight:bold'";
          let conflitoEspaco = espacoOcupado ? estilo : "";
          let espaco = `<td ${conflitoEspaco}>${evt.espaco.nome}</td>`;
          let data = this.formatarData(this.comanda.data);
          let hora = this.verificarEformatarHora(evt.hora);
          let conflitoProfissional = profissionalOcupado ? estilo : "";
          let profissional = `<td ${conflitoProfissional}>${evt.profissionais.responsavel.nomeFantasia}</td>`;
          body += `<tr><td>${data}</td><td>${evt.servico.nome}</td>${espaco}<td>${hora}</td><td>${evt.duracao}</td>${profissional}</tr>`;
          existeEventoIndisponivel = true;
        } else {
          if (!existeEventoIndisponivel) {
            evt.data = nova;
            listaEventos.push(evt);
          }
        }
      }

      if (existeEventoIndisponivel) {
        html = inicio + body + final;
        await alerts.exibirErroHtml("Agendamento indisponível", html);
        this.comanda.data = dataAntiga;
      } else {
        for (let e of listaEventos) {
          await this.upsertLockEvento(e, false);
        }
      }
      await this.$refs.janelaCarregando.fechar();
    },
    async inicializarHelperHora(item) {
      this.itemEditado.hora = this.verificarEformatarHora(item.hora);
    },
    async salvarHoraDialog(item) {
      let eventoEmUso = await this.isEventoEmUso(
        this.itemEditado.hora,
        item.duracao,
        item.profissionais.responsavel.id,
        item.espaco.id,
        this.comanda.data
      );

      if (!eventoEmUso) {
        item.hora = this.itemEditado.hora;
        item.data = this.comanda.data;
        await this.upsertLockEvento(item);
      }
    },
    async inicializarHelperEspaco(item) {
      this.itemEditado.espaco = item.espaco;
    },
    async salvarEspacoDialog(item) {
      let eventoEmUso = await this.isEventoEmUso(
        item.hora,
        item.duracao,
        item.profissionais.responsavel.id,
        this.itemEditado.espaco.id,
        this.comanda.data
      );

      if (!eventoEmUso) {
        item.espaco = this.itemEditado.espaco;
        item.data = this.comanda.data;
        await this.upsertLockEvento(item);
      }
    },
    async upsertLockEvento(item, exibirMensagem = true) {
      if (item.idLock > 0) await this.editarLockEvento(item, exibirMensagem);
      else await this.addLockEvento(item, exibirMensagem);
    },
    async salvarProfissionaisDialog(item) {
      let eventoEmUso = await this.isEventoEmUso(
        item.hora,
        item.duracao,
        this.profissionaisEvento.responsavel.id,
        item.espaco.id,
        this.comanda.data
      );
      if (eventoEmUso) return;

      this.comanda.eventos[
        this.profissionaisEventoIndice
      ].profissionais.responsavel = this.profissionaisEvento.responsavel;
      this.comanda.eventos[
        this.profissionaisEventoIndice
      ].profissionais.auxiliares = this.profissionaisEvento.auxiliares;
      this.comanda.eventos[this.profissionaisEventoIndice].data =
        this.comanda.data;

      await this.editarLockEvento(
        this.comanda.eventos[this.profissionaisEventoIndice],
        true
      );
      this.close();
    },
    close() {
      setTimeout(() => {
        this.profissionaisEvento = Object.assign(
          {},
          {
            responsavel: {
              id: null,
              nomeFantasia: "Sem profissional",
              preferencial: false,
            },
            auxiliares: [],
          }
        );
        this.profissionaisEventoIndice = -1;
      }, 300);
    },
    listarProfissionais(profissionais) {
      if (profissionais.responsavel != null) {
        const { responsavel, auxiliares } = profissionais;

        const listaProfissionais = [responsavel, ...auxiliares];

        const listaProfissionaisNome = listaProfissionais.map(
          (pro) => pro.nomeFantasia
        );

        return listaProfissionaisNome.join(", ");
      } else return "Sem profissional";
    },
    async abrir(parametros = {}) {
      this.statusEnviado = false;

      if (this.parametros.permissoes.permissoesComanda.alterarCriarComandas == "N") {
        this.semPermissaoAlterarCriarComandas = true;
        await alerts.exibirInformacao(
          "Sem permissão",
          "Permissões de Usuário > SERVIÇOS (NOVO) > AGENDA > Alterar/Criar comandas."
        );
        if (!parametros.idComanda) {
          this.fechar();
          return;
        }
      }
      await this.limparLockEventos();
      this.telaSignatarios = false;
      if (parametros.idComanda)
        await this.carregarComanda(parametros.idComanda);
      else {
        this.visibilidadePaineis = [true, false, false];
        this.comanda.data = parametros.data || moment().format("YYYY-MM-DD");
      }
      this.aberto = true;
      this.sugestoes = parametros.sugestoes || {
        idProfissional: null,
        idEspaco: null,
        horario: null,
      };
      try {
        if (this.parametros.configuracoesServicos.permiteReservarEquipamentos) {
          await this.carregarTiposEquipamentos();
        }
        if (
          !this.parametros.configuracoesServicos
            .restringeServicosPorProfissional
        ) {
          [this.tiposServico, this.espacos, this.profissionaisBackend] = (
            await this.enviarEAguardarBackend([
              ApiService.get("tiposServico"),
              ApiService.get("espacos"),
              ApiService.get("profissionais/comDisponibilidade"),
            ])
          ).map((r) => r.data);
        } else {
          [this.tiposServico, this.espacos, this.profissionaisBackend] = (
            await this.enviarEAguardarBackend([
              ApiService.get("tiposServico/tiposPorProfissional"),
              ApiService.get("espacos"),
              ApiService.get("profissionais/porServico"),
            ])
          ).map((r) => r.data);
        }
      } catch (e) {
        await alerts.exibirErro(
          "Não foi possível abrir a tela de novo agendamento",
          e
        );
        this.fechar();
      }
      this.inicializarNovoEvento();
      this.limparFormularioProduto();
    },
    getCorIconeFormulario(evento) {
      this.verificarAcessoAtendimentoProntuario();
      if (evento.idFormularioPreenchido) return "green";
      if (evento.servico.formulario)
        return evento.servico.formulario.obrigatorio ? "red" : "yellow";
      return null;
    },
    getTooltipFormulario(evento) {
      if (evento.idFormularioPreenchido)
        return "Ficha de acompanhamento preenchida";
      if (evento.servico.formulario) {
        return evento.servico.formulario.obrigatorio
          ? "Ficha de acompanhamento obrigatória não preenchida"
          : "Ficha de acompanhamento opcional não preenchida";
      }
      return null;
    },
    dispararAtualizacoes() {
      eventos.barramento.$emit(eventos.COMANDA_ALTERADA);
    },
    async trocarCliente(cliente) {
      if (cliente) {
        this.verificarComandaAberta();
        if (this.comanda.cliente.aniversariante) {
          alerts.exibirMensagemComImagem(
            cake,
            80,
            80,
            "Parabéns!",
            "Hoje é aniversário do cliente!"
          );
        }
        var ehPrimeiroAgendamento = false;
        if (this.comanda.cliente.id != null)
          ehPrimeiroAgendamento = await this.getClienteNovo(
            this.comanda.cliente.id
          );
        if (ehPrimeiroAgendamento) {
          await alerts.exibirInformacao(
            "Atenção",
            "É a primeira vez que " +
              this.comanda.cliente.nome +
              " está agendando nesta loja."
          );
        }
        this.carregaObservacaoCliente();
      }
    },
    async carregarComanda(id) {
      try {
        const respostas = await this.enviarEAguardarBackend([
          ApiService.getComanda(id),
        ]);
        this.comanda = respostas[0].data;
        this.idComanda = this.comanda.id;

        if (this.comanda.eventos.length > 0) {
          this.faltou.carregando = this.comanda.eventos.filter(
            (faltaram) => faltaram.situacao.toUpperCase() === "FALTOU"
          );
        }

        if (this.comanda.idNumeroManual == null)
          this.comanda.idNumeroManual = this.comanda.id;

        if (!this.comanda.statusJaPresenteOuExecutado) {
          if (this.consultaStatusPresenteExecutado())
            this.comanda.statusJaPresenteOuExecutado = true;
        }
        this.somarDesconto();
      } catch (e) {
        await alerts.exibirErro(e);
      }
      this.visibilidadePaineis = [
        !!this.comanda.eventos.length,
        !!this.comanda.produtos.length,
        !!this.comanda.insumos.length,
      ];
    },
    limparComanda() {
      this.comanda = {
        id: null,
        idNumeroManual: null,
        statusJaPresenteOuExecutado: false,
        data: moment().format("YYYY-MM-DD"),
        fechada: false,
        noiva: false,
        desconto: null,
        observacoes: null,
        cliente: { id: null },
        eventos: [],
        produtos: [],
        insumos: [],
        equipamentos: []
      };
    },
    limparFormulario() {
      this.limparComanda();
      this.visibilidadePaineis = [true, false, false];
      this.novoEvento = {
        servicoAvulso: false,
        avaliacao: false,
        tipoServico: null,
        servico: null,
        espaco: null,
        profissional: {
          id: null,
          nomeFantasia: "Sem profissional",
        },
        profissionalPreferencial: false,
        duracao: null,
        horario: null,
        situacao: "Agendado",
        aplicandoDesconto: false,
      };
      this.limparFormularioProduto();
      this.limparFormularioInsumo();
      if(this.parametros.configuracoesServicos.permiteReservarEquipamentos)
        this.limparFormularioEquipamento();
    },
    fechar(atualizar = false, vemDeOperacaoSalvar = false) {
      if (!vemDeOperacaoSalvar && this.excluirDocumentosDeAssinatura)
        this.cancelarDocumentosDigitais();
      if (atualizar) this.dispararAtualizacoes();

      this.limparLockEventos();
      this.aberto = false;
      this.limparFormulario();
      this.idComanda = null;
      this.idFormularioPreenchido = null;
    },
    cancelarDocumentosDigitais() {
      try {
        this.comanda.eventos.forEach((e) => {
          if (e.chave != null && e.chave !== "")
            this.cancelarDocumentoDigitalD4Sign(e.chave);
        });
      } catch (e) {
        console.log("Não foi possível cancelar assinatura de documentos", e);
      }
    },
    cancelarDocumentoDigitalD4Sign(chave) {
      ApiService.delete(`assinatura/cancelarFicha/${chave}`);
    },
    verificarComandaAberta() {
      if (!this.comanda.id && this.comanda.cliente.id && this.comanda.data) {
        ApiService.get(
          `comandas/abertas/${moment(this.comanda.data).format("YYYY-MM-DD")}/${
            this.comanda.cliente.id
          }`
        ).then((r) => {
          if (r.status === 200) {
            this.comanda = r.data;

            if (this.comanda.idNumeroManual == null)
              this.comanda.idNumeroManual = this.comanda.id;
            if (
              !this.comanda.statusJaPresenteOuExecutado &&
              this.consultaStatusPresenteExecutado()
            )
              this.comanda.statusJaPresenteOuExecutado = true;
            this.inicializarNovoEvento();
            this.somarDesconto();
          }
        });
      }
    },
    carregarServicosAvulsosPorTipo(tipo) {
      if (tipo) {
        if (
          !this.parametros.configuracoesServicos
            .restringeServicosPorProfissional
        )
          ApiService.get(`servicos/avulsos/${tipo.id}`).then((r) => {
            this.servicosAvulsos = r.data;
          });
        else {
          ApiService.get(
            `servicos/avulsosPorProfissional/${tipo.id}/${
              this.novoEvento.profissional.id != null
                ? this.novoEvento.profissional.id
                : 0
            }`
          ).then((r) => {
            this.servicosAvulsos = r.data;
          });
        }
      } else this.servicosAvulsos = [];
    },
    adicionarProduto(novoProduto) {
      const quantidade = parseInt(novoProduto.quantidade);
      const produtoInserido = this.comanda.produtos.find(p => p.id === novoProduto.produto.id);
      if (produtoInserido) produtoInserido.quantidade = parseFloat(produtoInserido.quantidade) + quantidade;
      else {
        this.comanda.produtos.push({
          id: novoProduto.produto.id,
          profissional: novoProduto.profissional,
          nome: novoProduto.produto.nome,
          valorBruto: novoProduto.produto.preco,
          quantidade: quantidade,
          desconto: null,
          permiteDesconto: novoProduto.produto.permiteDesconto,
          percentualMaximoDesconto: novoProduto.produto.percentualMaximoDesconto,
        });
      }
    },
    adicionarEquipamento(novoEquipamento) {
      this.comanda.equipamentos.push({
        id: novoEquipamento.equipamento.id,
        descricao: novoEquipamento.equipamento.descricao,
      });
    },
    async adicionarInsumo(novoInsumo) {
      if (!this.$refs.formInclusaoInsumo.validate()) return;

      const quantidade = parseFloat(novoInsumo.quantidade);
      const insumoInserido = this.comanda.insumos.find(p => p.id === novoInsumo.produto.id);

      if (this.parametros.configuracoesServicos.utilizaBaixaManualEstoque) {
        let quantidadeSaldo = (await ApiService.get(`produtos/saldo/${novoInsumo.produto.id}`)).data;
        let quantidadeUtilizada = insumoInserido ? parseFloat(insumoInserido.quantidade) + quantidade : quantidade;

        if (quantidadeUtilizada > quantidadeSaldo){
          if (this.parametros.configuracoesEmpresa.bloquearProdutosSemSaldoEstoque){
            await alerts.exibirErro(
              "Erro ao inserir insumo",
              "O insumo " + novoInsumo.produto.nome + " não possui saldo suficiente em estoque"
            );
            return;

          } else {
            if(!await alerts.pedirConfirmacao(
              "Erro ao inserir insumo",
              "O insumo " + novoInsumo.produto.nome + " não possui saldo suficiente em estoque. Deseja continuar?")){
                return;
              }
          }
        }
      }

      if (insumoInserido)
      {
        insumoInserido.quantidade = parseFloat(insumoInserido.quantidade) + quantidade;
        insumoInserido.entregue = false;
      } else {
        this.comanda.insumos.push({
          id: novoInsumo.produto.id,
          profissional: novoInsumo.profissional,
          nome: novoInsumo.produto.nome,
          valorBruto: novoInsumo.produto.preco,
          quantidade: quantidade,
          unidadeControle: novoInsumo.produto.unidadeControle,
          desconto: null,
        });
      }
    },
    async adicionarMultiProduto(novoProduto) {
      if (!this.$refs.formInclusaoProduto.validate()) return;

      if (
        novoProduto.profissional == null ||
        novoProduto.profissional == undefined
      ) {
        await alerts.exibirErro(
          "Erro ao inserir produto",
          "É necessário informar um profissional para venda do produto"
        );
        return;
      }

      if (novoProduto.produto != null) {
        const produtoLocal = novoProduto;
        novoProduto.produto.forEach((produto) => {
          produtoLocal.produto = produto;
          this.adicionarProduto(produtoLocal);
        });
        this.limparFormularioProduto();
      }
    },
    async adicionarMultiEquipamento(novoEquipamento) {
      if (!this.$refs.formInclusaoEquipamentos.validate()) return;
      var qtdEquipamentos = 0;
      novoEquipamento.equipamento.forEach(e => {
        if(e.status !== 1) {
          qtdEquipamentos = qtdEquipamentos + 1;
      }
      });

      if(qtdEquipamentos > 0) {
        await alerts.exibirErro(
            "Erro ao inserir equipamento(s)",
            "O(s) Status do(s) equipamento(s) deve(m) estar como 'Ativo'."
          );
          return;
      }

      var mensagem = '';
      if (novoEquipamento.equipamento != null) {
        const equipamentoLocal = novoEquipamento;
        novoEquipamento.equipamento.forEach((equipamento) => {
          var existe = this.comanda.equipamentos.find(e => e.id == equipamento.id);
          if(existe != undefined && existe.id > 0) {
            mensagem = mensagem + `O Equipamento '${equipamento.descricao}' já foi adicionado a lista. <br/>`
          }
        });

        if(mensagem.length > 0) {
          alerts.exibirInformacao(mensagem);
          return;
        }

        let comanda = {
          equipamentos: novoEquipamento.equipamento,
          eventos: this.comanda.eventos
        };

        var response = await this.enviarEAguardarBackend([ApiService.post(`equipamentos/validarEquipamentosOcupados`, comanda),]);
        if(response.length > 0 && response[0].data.length > 0) {
          alerts.exibirInformacao(response[0].data);
          return;
        }

        novoEquipamento.equipamento.forEach((equipamento) => {
          equipamentoLocal.equipamento = equipamento;
          this.adicionarEquipamento(equipamentoLocal);
        });
        this.limparFormularioEquipamento();
      }
    },
    async adicionarMultiInsumo(novoInsumo) {
      if (!this.$refs.formInclusaoInsumo.validate()) return;

      if (novoInsumo.produto != null) {
        const insumoLocal = novoInsumo;
        for(let produto of novoInsumo.produto) {
          insumoLocal.produto = produto;
          if (!await this.adicionarInsumo(insumoLocal)) continue;
        }
        this.limparFormularioInsumo();
      }
    },
    limparFormularioProduto() {
      this.novoProduto = {
        produto: null,
        quantidade: null,
        profissional: null,
      };
      this.$refs.formInclusaoProduto.resetValidation();
    },
    limparFormularioEquipamento() {
      this.novoEquipamento = {
        equipamento: null
      };
      if (this.$refs["formInclusaoEquipamentos"])
        this.$refs.formInclusaoEquipamentos.resetValidation();
    },
    limparFormularioInsumo() {
      this.novoInsumo = {
        produto: null,
        quantidade: null,
        profissional: null,
        unidadeControle: null,
      };
      if (this.$refs["formInclusaoInsumo"])
        this.$refs.formInclusaoInsumo.resetValidation();
    },
    async adicionarEvento(novoEvento, horaNova) {
      /* Adequação para o cálculo consecutivo de hora */
      let evento = {
        idLock: 0,
        data: this.comanda.data,
        servicoAvulso: novoEvento.servicoAvulso,
        avaliacao: novoEvento.avaliacao,
        servico: novoEvento.servico,
        idMovimentacao: novoEvento.servico.idMovimentacao,
        espaco: novoEvento.espaco,
        profissionais: novoEvento.profissional
          ? {
              responsavel: {
                id: novoEvento.profissional.id,
                nomeFantasia: novoEvento.profissional.nomeFantasia,
                preferencial: novoEvento.profissionalPreferencial,
              },
              auxiliares: [],
            }
          : null,
        hora: horaNova,
        situacao: novoEvento.situacao,
        duracao: novoEvento.servico.duracao,
        valorBruto: novoEvento.servicoAvulso ? novoEvento.servico.preco : 0,
        aplicandoDesconto: novoEvento.aplicandoDesconto,
        desconto: null,
        idFormularioPreenchido: null,
        chave: null,
      };

      var horaFinalEvento = moment(evento.hora, "hh:mm").add(
        evento.duracao,
        "m"
      );
      var horaLimite = moment(this.parametros.horaFinal, "hh:mm");
      if (horaLimite.isBefore(horaFinalEvento)) {
        if (
          !(await alerts.pedirConfirmacao(
            "Horário limite",
            "O horário previsto para o término desse serviço ultrapassa o horário final do expediente, é recomendado agendar um novo horário. Deseja continuar?"
          ))
        ) {
          await this.inicializarNovoEvento();
          return;
        }
      }

      this.comanda.eventos.push(evento);
      await this.addLockEvento(evento);
      await this.inicializarNovoEvento();
    },
    async adicionarMultiEvento(novoEvento) {

      if (!this.$refs.formInclusaoEvento.validate()) return;

      if (
        this.comanda.cliente.id == null ||
        this.comanda.cliente == undefined
      ) {
        await alerts.exibirErro(
          "Erro ao inserir serviço",
          "É necessário informar um cliente antes de inserir um serviço"
        );
        return;
      }

      if (novoEvento.profissional.id == null) {
        await alerts.exibirErro(
          "Erro ao inserir serviço",
          "É necessário informar um profissional para realização do serviço"
        );
        return;
      }

      this.servicoIntervalo = await ApiService.get(
        `servicos/servicoIntervalo/${this.comanda.cliente.id}/${this.novoEvento.servico[0].id}/${this.comanda.data}`
      );
      this.servicoIntervaloData = await ApiService.get(
        `servicos/servicoIntervaloData/${this.comanda.cliente.id}/${this.novoEvento.servico[0].id}`
      );
      this.servicoIntervaloDias = await ApiService.get(
        `servicos/servicoIntervaloDias/${this.comanda.cliente.id}/${this.novoEvento.servico[0].id}`
      );

      var dataOriginalUltimoServico = moment(this.servicoIntervaloData.data);
      dataOriginalUltimoServico.subtract(this.servicoIntervaloDias.data, "days");

      var dataOriginalUltimoServicoTratada = dataOriginalUltimoServico.format("YYYY/MM/DD");
      var dataComandaTratada = moment(this.comanda.data).format("YYYY/MM/DD");

      if (
        this.servicoIntervalo.data == false &&
        dataOriginalUltimoServicoTratada < dataComandaTratada
      ) {
        await alerts.exibirErro(
          "Não é possível agendar o serviço " +
            [this.novoEvento.servico[0].nome] +
            " em um intervalo menor do que " +
            [this.servicoIntervaloDias.data] +
            " dias do último atendimento. O próximo atendimento para este cliente poderá ocorrer a partir de " +
            [moment(this.servicoIntervaloData.data).format("DD/MM/YYYY")] +
            ""
        );
        return;
      }
      if (
        this.servicoIntervalo.data == false &&
        dataOriginalUltimoServicoTratada >= dataComandaTratada
      ) {
        await alerts.exibirErro(
          "O serviço " +
            [this.novoEvento.servico[0].nome] +
            " já está agendado. A data do agendamento é: " +
            dataOriginalUltimoServico.format("DD/MM/YYYY") +
            ""
        );
        return;
      }

      let eventoEmUso = await this.isEventoEmUso(
        novoEvento.horario,
        this.converterFormatoHoraMinutoEmMinutos(novoEvento.duracao),
        novoEvento.profissional.id,
        novoEvento.espaco.id,
        this.comanda.data
      );
      if (eventoEmUso) return;

      if (novoEvento.servico != null) {
        let duracao = 0;
        let horaMinuto;
        let horaNova = 0;
        let splitedHour = novoEvento.horario.split(":");
        let eventoLocal = novoEvento;
        if (novoEvento.duracao != null) {
          novoEvento.duracao = this.converterFormatoHoraMinutoEmMinutos(
            novoEvento.duracao
          );
          eventoLocal.duracao = novoEvento.duracao;
        }
        novoEvento.servico.forEach((servico) => {
          eventoLocal.servico = servico;

          horaMinuto = moment()
            .hour(Number(splitedHour[0]))
            .minute(Number(splitedHour[1]))
            .add(duracao, "m");

          if (novoEvento.duracao != null)
            duracao = duracao + Number(novoEvento.duracao);
          else {
            eventoLocal.duracao = servico.duracao;
            duracao = duracao + Number(servico.duracao);
          }

          if (horaMinuto.minute() == 0)
            horaNova = `${horaMinuto.hour()}:0${horaMinuto.minute()}`;
          else {
            if (horaMinuto.minute() <= 9)
              horaNova = `${horaMinuto.hour()}:0${horaMinuto.minute()}`;
            else horaNova = `${horaMinuto.hour()}:${horaMinuto.minute()}`;
          }
          this.adicionarEvento(eventoLocal, horaNova);
        });
      }
    },
    bloquearEdicaoEvento(evento) {
      return (
        this.somenteLeitura ||
        (!evento.emEdicao && evento.situacao === "Executado")
      );
    },
    inicializarNovoEvento() {
      this.novoEvento.tipoServico = null;
      this.novoEvento.servico = null;
      this.novoEvento.duracao = null;
      this.sugerirEspaco();
      this.novoEvento.horario = this.sugestoes.horario;
      this.$refs.formInclusaoEvento.resetValidation();
    },
    sugerirProfissional() {
      if (this.sugestoes.idProfissional) {
        this.novoEvento.profissional = this.profissionais.find((p) => {
          return p.id === this.sugestoes.idProfissional;
        });
      }
    },
    sugerirEspaco() {
      if (this.sugestoes.idEspaco) {
        this.novoEvento.espaco = this.espacos.find((e) => {
          return e.id === this.sugestoes.idEspaco;
        });
      } else this.novoEvento.espaco = this.espacos[0];
    },
    async excluirEvento(indice, item) {
      if (item.chave != null && item.chave !== "")
        this.cancelarDocumentoDigitalD4Sign(item.chave);
      this.deleteLockEvento(item);
      if (indice == 0 && this.comanda.eventos.length > 1)
        this.comanda.eventos[1].hora = this.comanda.eventos[0].hora;
      this.comanda.eventos.splice(indice, 1);
      if(this.comanda.eventos.length == 0) {
        if(this.parametros.configuracoesServicos.permiteReservarEquipamentos) {
          this.limparFormularioEquipamento();
          this.comanda.equipamentos = [];
        }
      }
      this.verificarAcessoAtendimentoProntuario();
    },
    excluirInsumo(indice) {
      this.comanda.insumos.splice(indice, 1);
    },
    excluirProduto(indice) {
      this.comanda.produtos.splice(indice, 1);
    },
    excluirEquipamento(indice) {
      this.comanda.equipamentos.splice(indice, 1);
    },
    deleteLockEvento(evento) {
      try {
        if (evento.idLock) ApiService.delete(`lock/${evento.idLock}`);
      } catch (e) {
        alerts.exibirErro(
          "Erro ao remover bloqueio",
          "Erro ao remover bloqueio de agendamento para evento.",
          e
        );
      }
    },
    async isEventoEmUso(horario, duracao, idProfissional, idEspaco, data) {
      let emUso = true;
      emUso = await this.isEspacoOcupado(horario, duracao, idEspaco, data);
      if (emUso) {
        await alerts.exibirErro(
          "Espaço indisponível!",
          "Um agendamento com este mesmo horário e espaço já está sendo inserido por outro usuário."
        );
      }

      if (!emUso) {
        emUso = await this.isProfissionalOcupado(
          horario,
          duracao,
          idProfissional,
          data
        );
        if (emUso) {
          await alerts.exibirErro(
            "Profissional indisponível!",
            "Um agendamento com este mesmo horário e profissional já está sendo inserido por outro usuário."
          );
        }
      }
      return emUso;
    },
    async isEspacoOcupado(
      horario,
      duracao,
      idEspaco,
      data,
      exibirMensagem = true
    ) {
      let emUso = true;
      try {
        let retorno = await this.enviarEAguardarBackend(
          [
            ApiService.get(
              `lock/espacoOcupado/${idEspaco}/${horario}/${duracao}/${data}`
            ),
          ],
          "Verificando disponibilidade do espaço",
          exibirMensagem
        );
        emUso = retorno[0].data;
      } catch (e) {
        await alerts.exibirErro(
          "Erro ao consultar disponibilidade",
          "Erro ao consultar disponibilidade de espaço para agendamento.",
          e
        );
      }
      return emUso;
    },
    async isProfissionalOcupado(
      horario,
      duracao,
      idProfissional,
      data,
      exibirMensagem = true
    ) {
      let emUso = true;

      try {
        let retorno = await this.enviarEAguardarBackend(
          [
            ApiService.get(
              `lock/profissionalOcupado/${idProfissional}/${horario}/${duracao}/${data}`
            ),
          ],
          "Verificando disponibilidade do profissional",
          exibirMensagem
        );
        emUso = retorno[0].data;
      } catch (e) {
        await alerts.exibirErro(
          "Erro ao consultar disponibilidade",
          "Erro ao consultar disponibilidade de profissional para agendamento.",
          e
        );
      }
      return emUso;
    },
    async addLockEvento(evento, exibirMensagem = true) {
      try {
        let retorno = await this.enviarEAguardarBackend(
          [ApiService.post(`lock`, evento)],
          "Reservando horário",
          exibirMensagem
        );
        evento.idLock = retorno[0].data;
      } catch (e) {
        await alerts.exibirErro(
          "Erro ao bloquear agendamento",
          "Erro ao bloquear disponibilidade de agendamento.",
          e
        );
      }
    },
    async editarLockEvento(evento, exibirMensagem = true) {
      try {
        await this.enviarEAguardarBackend(
          [ApiService.put(`lock`, evento)],
          "Reservando horário",
          exibirMensagem
        );
      } catch (e) {
        await alerts.exibirErro(
          "Erro ao editar lock agendamento",
          "Erro ao editar lock de agendamento.",
          e
        );
      }
    },
    async limparLockEventos() {
      try {
        ApiService.delete(`lock`);
      } catch (e) {
        await alerts.exibirErro(
          "Erro ao limpar lock de agendamentos",
          "Erro ao limpar lock de agendamentos.",
          e
        );
      }
    },
    async exibirLogComanda() {
      this.logComandas = true;
    },
    async exibirCompartilhamentoWeb(alterouStatus, servicoUnico, finalizar) {
      let servicos = "";
      servicos = this.comanda.eventos
        .map((evento) => evento.servico.nome)
        .join(", ");
      servicos = servicos.replace(/(.*), (.*)/, "$1 e $2");
      const nomeCliente = this.comanda.cliente.nome || "";
      const statusServico =
        alterouStatus && !servicoUnico
          ? this.comanda.eventos[0].situacao
          : finalizar || (alterouStatus && servicoUnico)
          ? this.novaSituacao
          : !finalizar
          ? "agendado(s)"
          : "";
      const hora =
        (alterouStatus && !servicoUnico) || (!alterouStatus && !servicoUnico)
          ? this.comanda.eventos[0].hora
          : alterouStatus && servicoUnico
          ? this.horaServicoAlterado
          : " ";
      const nomeFranquia = this.parametros.franquia.nome || "";
      const telefoneFranquia = this.parametros.franquia.telefone || "";
      const emailFranquia = this.parametros.franquia.email_emp || "";

      let mensagemCompartilhamento =
        this.parametros.configuracoes.mensagemCompartilhamentoStatusAgenda;
      mensagemCompartilhamento = mensagemCompartilhamento
        .replaceAll("{nomeCliente}", nomeCliente)
        .replaceAll(
          "{servicos}",
          !servicoUnico ? servicos : this.servicoAlterado
        )
        .replaceAll("{statusServico}", statusServico)
        .replaceAll("{telefoneEmpresa}", telefoneFranquia)
        .replaceAll("{emailEmpresa}", emailFranquia)
        .replaceAll("{empresa}", nomeFranquia)
        .replaceAll("{data}", moment(this.comanda.data).format("DD/MM/YYYY"))
        .replaceAll(
          "{hora}",
          hora.length > 5 ? moment(hora).format("HH:mm") : hora
        );

      let html =
        `<a style="text-decoration:none"  class="fc-bloqueios-button fc-button white--text fa fa-thumbs-up"
                    href="https://wa.me/${
                      this.comanda.cliente.telefoneCelular
                        ? "55" + this.comanda.cliente.telefoneCelular
                        : ""
                    }?text= ${encodeURIComponent(mensagemCompartilhamento)}."
                    target="_blank">
                      <img src="` +
        whatsapp +
        `"
                        aria-hidden="true"
                        class="v-icon material-icons theme--light white--text"
                        text-color="white"
                        style="height: 24px;"/>
                        &nbsp;WHATSAPP
                  </a>`;

      //Inserir o código abaixo na variável html para que apareça o botão de compartilhamento do Telegram
      // <a style="background-color:blue; text-decoration:none"  class="fc-bloqueios-button fc-button  white--text"
      //               href="https://t.me/${this.comanda.cliente.telefone ? "+55"+this.comanda.cliente.telefone : ""}?text=${encodeURIComponent(this.mensagemCompartilhamento)}."
      //               target="_blank">
      //               <i
      //                 aria-hidden="true"
      //                 class="v-icon material-icons theme--light white--text">
      //                 telegram</i>
      //               TELEGRAM
      //             </a>

      this.statusEnviado = await alerts.exibirMensagemCompatilhamento(
        `<p style="text-align: inherit;">Compartilhe a sua Agenda com seus clientes! Encaminhe o status do Agendamento<p>`,
        html
      );
    },
    async excluirComanda() {
      if (
        this.parametros.permissoes.permissoesComanda.excluirCancelarComandas ==
        "N"
      ) {
        await alerts.exibirInformacao(
          "Sem permissão",
          "Permissões de Usuário > SERVIÇOS (NOVO) > AGENDA > Excluir/Cancelar comandas."
        );
        return;
      }
      if (this.excluirBloqueadoPorParametro) {
        await alerts.exibirErro(
          "Operação não permitida!",
          "A exclusão de comandas abertas foi bloqueada para esta rede."
        );
        return;
      }
      try {
        if (
          await alerts.pedirConfirmacao(
            "Excluir a comanda?",
            "Esta ação não poderá ser desfeita!"
          )
        ) {
          await this.enviarEAguardarBackend(
            [ApiService.delete(`comandas/${this.comanda.id}`)],
            "Excluindo"
          );
          this.cancelarDocumentosDigitais();
          if (
            this.parametros.configuracoes.permissaoEnvioNotificacaoWhatsApp &&
            this.parametros.configuracoes
              .mensagemCompartilhamentoStatusAgenda != null &&
            this.parametros.configuracoes
              .mensagemCompartilhamentoStatusAgenda != ""
          ) {
            this.novaSituacao = "Cancelado";
            if (!this.statusEnviado)
              await this.exibirCompartilhamentoWeb(false, false, true);
          }
          this.fechar(true);
        }
      } catch (e) {
        alerts.exibirErro("Erro ao excluir comanda", e);
      }
    },
    async carregarFormulario(evento) {
      if (evento.idFormularioPreenchido) {
        await this.$refs.formDialog.visualizar(
          evento.idFormularioPreenchido,
          this.bloquearEdicaoEvento(evento),
          evento
        );
      } else {
        await this.$refs.formDialog.preencher(
          evento.servico.formulario.id,
          (id, chave) => {
            evento.idFormularioPreenchido = id;
            evento.chave = chave;
          },
          evento
        );
      }
    },
    async enviarEAguardarBackend(promises, texto, exibirMensagem = true) {
      if (exibirMensagem) {
        try {
          this.requisicaoEmAndamento = true;
          return await this.$refs.janelaCarregando.aguardarPromises(
            promises,
            texto
          );
        } finally {
          this.requisicaoEmAndamento = false;
        }
      } else {
        try {
          return await this.$refs.janelaCarregando.aguardarPromisesSemTexto(
            promises
          );
        } catch (e) {
          console.log("Falha ao enviar requisição: " + e);
        }
      }
    },
    retornaProfissionaisValidosParaOServico() {
      if (this.novoEvento.servico == null) {
        if (this.novoEvento.tipoServico != null)
          return this.profissionais.filter(
            (s) => s.idTipoServico === this.novoEvento.tipoServico.id
          );
        else return this.profissionais;
      }

      //Retorno da função
      var retornoProfissionais = [];
      for (
        let srvIndex = 0;
        srvIndex < this.novoEvento.servico.length;
        srvIndex++
      ) {
        const srvCorrente = this.novoEvento.servico[srvIndex];

        if (srvIndex == 0) {
          for (
            let profIndex = 0;
            profIndex < this.profissionais.length;
            profIndex++
          ) {
            const profCorrente = this.profissionais[profIndex];

            if (profCorrente.idServico == srvCorrente.id) {
              var existeProfissional = false;

              if (retornoProfissionais != null) {
                for (
                  let verProf = 0;
                  verProf < retornoProfissionais.length;
                  verProf++
                ) {
                  const retProf = retornoProfissionais[verProf];

                  if (
                    retProf.idServico == profCorrente.idServico &&
                    retProf.id == profCorrente.id
                  )
                    existeProfissional = true;
                }
              }

              if (existeProfissional == false)
                retornoProfissionais.push(profCorrente);
            }
          }
        } else {
          if (retornoProfissionais != null) {
            for (
              let profHabIndex = retornoProfissionais.length;
              profHabIndex > 0;
              profHabIndex--
            ) {
              const profHabCorrente = retornoProfissionais[profHabIndex - 1];

              var profissionalHabilitadoemAmbos = false;
              for (
                let profIndex = 0;
                profIndex < this.profissionais.length;
                profIndex++
              ) {
                const profCorrente = this.profissionais[profIndex];

                if (
                  profCorrente.idServico == srvCorrente.id &&
                  profCorrente.id == profHabCorrente.id
                ) {
                  profissionalHabilitadoemAmbos = true;
                  break;
                }
              }

              if (!profissionalHabilitadoemAmbos)
                retornoProfissionais.splice(profHabIndex - 1, 1);
            }
          }
        }
      }
      return retornoProfissionais;
    },

    async salvarComanda(finalizar = false) {
      if (finalizar && this.parametros.permissoes.permissoesComanda.finalizarComandas == "N") {
        await alerts.exibirInformacao("Sem permissão", "Permissões de Usuário > SERVIÇOS (NOVO) > AGENDA > Finalizar comandas.");
        return;
      }

      const novosEventosFaltou = this.comanda.eventos.filter(
        (validarFaltaram) => {
          const alterou = this.faltou.carregando.indexOf(validarFaltaram) == -1;
          return validarFaltaram.situacao.toUpperCase() == "FALTOU" && alterou;
        }
      );

      const todasSituacoesFaltantes = this.comanda.eventos.filter((faltou) => {
        return faltou.situacao.toUpperCase() == "FALTOU";
      });

      const todasSituacoesExecutadas = this.comanda.eventos.filter(
        (executou) => {
          return executou.situacao.toUpperCase() == "EXECUTADO";
        }
      );

      let msg = "";

      if (this.comanda.eventos.length > 0 &&
        ((novosEventosFaltou.length == 1 && this.comanda.eventos.length == 1) ||
          todasSituacoesFaltantes.length == this.comanda.eventos.length ||
          todasSituacoesFaltantes.length + todasSituacoesExecutadas.length == this.comanda.eventos.length
        )
      ) {

        finalizar = true;

        msg = `Não será mais possível modifica-la.`;

        if (this.parametros.permissoes.permissoesComanda.finalizarComandas == "N") {
          await alerts.exibirInformacao( "Sem permissão", "Todos os eventos estão executados ou cancelados. Permissões de Usuário > SERVIÇOS (NOVO) > AGENDA > Finalizar comandas.");
          return;
        }
      }

      if(this.parametros.numeracaoDaComandaManual && this.comandaComStatusPresenteOuExecutado && this.comanda.idNumeroManual != null) {
        var idComandaAtual = this.comanda.id;
        if (this.novoRegistro){
          idComandaAtual = 0;
        }

        var numeroComandaEmUso = false;
        await ApiService.get(`comandas/byIdNumeroManual/${this.comanda.idNumeroManual}/${idComandaAtual}`).then((r) => {
          if (r.status === 200){
            numeroComandaEmUso = true;
          }
        });

        if (numeroComandaEmUso) {
          await alerts.exibirErro('Numeração já utilizada!','O número de comanda inserido já está em uso, altere o número informado.');
          return;
        }
      }

      let flagFaltou = false;

      if (finalizar) {
        var msgPadraoFinalizarComanda = `Os agendamentos em aberto serão marcados como executados e não será mais possível modificar a comanda`;
        var msgPadrao = `Deseja marcar os demais serviços com a situação "Faltou"? Não \n será mais possível modificar a comanda`;

        if(novosEventosFaltou.length > 0 && this.comanda.eventos.length > 1 && (await alerts.pedirConfirmacao("Finalizar a comanda?", msg == "" ? msgPadrao : msg))) {
          flagFaltou = true;
        } else if (novosEventosFaltou.length == this.comanda.eventos.length) {
          flagFaltou = true;
        } else if (!(await alerts.pedirConfirmacao("Finalizar a comanda?", msg == "" ? msgPadraoFinalizarComanda : msg))) {
          return;
        }

        let necessarioInstalacaoScarf = false;
        if (this.parametros.configuracoesServicos.execucaoServicoComConfirmacaoBiometrica) {
          let estaCadastradoBiometria = false;
          estaCadastradoBiometria = await this.verificarCadastroBiometria();
          if (estaCadastradoBiometria){
            if (await alerts.pedirConfirmacao(
                "Finalizar a comanda?",
                "Caso deseje validar a digital clique em Sim, caso deseje prosseguir sem a validação clique em Não."
              )){
                let biometriaCapturada = "";
                biometriaCapturada = await this.capturarBiometria();
                if (biometriaCapturada.length > 0){
                  let compararBiometrias = "";
                  compararBiometrias = await this.compararBiometrias(biometriaCapturada);
                  if (compararBiometrias == "False") {
                    await alerts.exibirErro(
                      "Erro!",
                      `Digital não é compatível com a cadastrada.`
                    );
                    return;
                  }
                } else {
                  if (
                    await alerts.pedirConfirmacaoAtencao(
                      "Atenção!",
                      "Para utilizar este recurso neste navegador, é necessário a instalação do aplicativo Linx Scarf ou que seja iniciado.\n Clique em OK para prosseguir."
                    )
                  ) {
                    window.open(window.location.href + "scarf", "_blank");
                    necessarioInstalacaoScarf = true;
                  }
                  return;
                }
              }
          }
          else {
            if (await alerts.pedirConfirmacao(
              "Finalizar a comanda?",
              "Verificamos que a Biometria não está cadastrada. Caso deseje cadastrar clique em Sim, caso deseje prosseguir sem cadastramento clique em Não."
            ))
            {
              let biometriaCadastrada = "";
              biometriaCadastrada = await this.cadastrarBiometria();
              if (biometriaCadastrada.length > 0) {
                let atualizarBiometria = "";
                atualizarBiometria = await this.atualizarBiometriaCliente(biometriaCadastrada)
                if(atualizarBiometria){
                  await alerts.exibirSucessoHtml("Digital cadastrada com sucesso! Finalize a comanda novamente para validar a digital");
                  return;
                }
                else {
                  await alerts.exibirErro(
                    "Erro!",
                    `Não foi possível cadastrar a digital.`
                  );
                  return;
                }
              }
              else {
                if (
                  await alerts.pedirConfirmacaoAtencao(
                    "Atenção!",
                    "Para utilizar este recurso neste navegador, é necessário a instalação do aplicativo Linx Scarf ou que seja iniciado.\n Clique em OK para prosseguir."
                  )
                ) {
                  window.open(window.location.href + "scarf", "_blank");
                  necessarioInstalacaoScarf = true;
                }
                return;
              }
            }
          }
        }

        if (necessarioInstalacaoScarf) return;
      } else if (
        novosEventosFaltou.length > 0 &&
        this.comanda.eventos.length > 1 &&
        (await alerts.pedirConfirmacao(
          "Finalizar a comanda?",
          'Deseja marcar os demais serviços com a situação "Faltou"? Não\n' +
            "será mais possível modificar a comanda"
        ))
      ) {
        flagFaltou = true;
      }

      this.somarDesconto();

      var comanda = await this.parseComanda(flagFaltou);

      try {
        if (this.novoRegistro) {
          var response = await this.enviarEAguardarBackend([
            ApiService.post("comandas", comanda),
          ]);
          this.comanda.id = response[0].data;
        } else {
          await this.enviarEAguardarBackend([
            ApiService.put(`comandas/${this.comanda.id}`, comanda),
          ]);
        }

        if (finalizar) {
          comanda = await this.parseComanda(flagFaltou, true, true);
          var resposta = await this.enviarEAguardarBackend([
            ApiService.put(`comandas/fecharComanda/${this.comanda.id}`, comanda),
          ]);
        }

        let identificador = finalizar ? (this.isGuidVazio(resposta[0].data.identificador) ? null : resposta[0].data.identificador) : null;

        if (!flagFaltou){
          await this.mensagemSucessoComandaPreVenda(comanda, identificador);
        }

        if(this.parametros.configuracoes.permissaoEnvioNotificacaoWhatsApp
          && this.parametros.configuracoes.mensagemCompartilhamentoStatusAgenda != null
          && this.parametros.configuracoes.mensagemCompartilhamentoStatusAgenda != "")
        {
          this.novaSituacao = finalizar ? "Executado" : "";
          if(!this.statusEnviado){
            await this.exibirCompartilhamentoWeb(false, false, finalizar);
          }
        }

        this.fechar(true, true);
      } catch (e) {
        await alerts.exibirErro(`Não foi possível ${finalizar ? "finalizar" : "salvar"} a comanda`, e);
      }
    },

    async iniciarAtendimentoProntuario() {

      erpWebApiService.criarProntuario(this.idComanda)
    },

    async parseComanda(faltou, finalizar = false, carregarComanda = false) {

      if(this.comanda.id && carregarComanda){
        try{
          const response = await this.enviarEAguardarBackend([
            ApiService.getComanda(this.comanda.id),
          ]);
          this.comanda = response[0].data;
        } catch (e) {
          await alerts.exibirErro(e);
        }
      }

      const objComanda = {
        idCliente: this.novoRegistro ? this.comanda.cliente.id : undefined,
        data: this.comanda.data,
        noiva: this.comanda.noiva,
        observacoes: this.comanda.observacoes || null,
        desconto: this.comanda.desconto,
        fechada: finalizar,
        idNumeroManual: this.comanda.idNumeroManual,
        eventos: this.comanda.eventos.map((e) => {
          let descontoEvento = e.desconto
            ? {
                tipo: e.desconto.tipo,
                valor: parseFloat(e.desconto.valor.toFixed(2)),
              }
            : undefined;
          return {
            id: e.id || null,
            hora: e.hora,
            servicoAvulso: e.servicoAvulso,
            avaliacao: e.avaliacao || false,
            cortesiaAvulso: e.servicoAvulso && e.cortesiaAvulso,
            duracao: e.duracao,
            idServico: e.servicoAvulso ? e.servico.id : undefined,
            NumeroAntecipacao:  e.servico.numeroAntecipacao,
            idClienteServico: !e.servicoAvulso
              ? (finalizar ? e.idClienteServico : e.servico.idClienteServico)
              : undefined,
            idMovimentacao: e.idMovimentacao,
            idEspaco: e.espaco.id,
            desconto: descontoEvento,
            profissionais:
              e.profissionais &&
              e.profissionais.responsavel &&
              e.profissionais.responsavel.id
                ? {
                    responsavel: {
                      id: e.profissionais.responsavel.id,
                      preferencial: e.profissionais.responsavel.preferencial,
                    },
                    auxiliares: [...e.profissionais.auxiliares],
                  }
                : {
                    responsavel: null,
                    auxiliares: [],
                  },
            situacao:
              faltou && e.situacao !== "Executado" ? "Faltou" : e.situacao,
            idFormularioPreenchido: e.idFormularioPreenchido || null,
            chave: e.chave || null,
          };
        }),
        produtos: this.comanda.produtos.map((p) => {
          let descontoProduto = p.desconto
            ? {
                tipo: p.desconto.tipo,
                valor: parseFloat(p.desconto.valor.toFixed(2)),
              }
            : undefined;
          return {
            id: p.id,
            quantidade: p.quantidade,
            idProfissional: p.profissional && p.profissional.id,
            desconto: descontoProduto,
          };
        }),
        equipamentos: this.comanda.equipamentos.map((e) => {
          return {
            id: e.id,
            descricao: e.descricao,
          };
        }),
        insumos: this.comanda.insumos.map((p) => {
          return {
            idInsumo: p.id,
            quantidade: p.quantidade,
            unidadeControle: p.unidadeControle,
            nome: p.nome,
            idProfissional: p.profissional && p.profissional.id,
            entregue: p.entregue,
            dataSolicitacao: p.dataSolicitacao,
            dataExpedicao: p.dataExpedicao,
          };
        }),
        impressaoUnica: this.comanda.impressaoUnica,
        impressaoMultipla: this.comanda.impressaoMultipla,
      };

      return objComanda;
    },

    async verificarCadastroBiometria() {
      try {
        const respostas = await this.enviarEAguardarBackend([biometriaApiService.verificarCadastro(this.comanda.cliente.id),]);
        return respostas[0];
      } catch (e) {
        return false;
      }
    },

    async capturarBiometria() {
      try {
        const respostas = await this.enviarEAguardarBackend([ScarfClientService.Capturar(),]);
        return respostas[0];
      } catch (e) {
        return '';
      }
    },

    async compararBiometrias(biometriaCapturada) {
      let request = await this.montarObjetoValidarBiometria(biometriaCapturada);
      try {
        const respostas = await this.enviarEAguardarBackend([ScarfClientService.Verificar(request),]);
        return respostas[0];
      } catch (e) {
        return '';
      }
    },

    async montarObjetoValidarBiometria(biometriaCapturada) {
      return {
            biometria: biometriaCapturada,
            idCliente: this.comanda.cliente.id,
            urlCrm: apiConfig.getUrlCrmApi(),
            token: apiConfig.getToken()
          };
    },

    async cadastrarBiometria() {
      try {
        const respostas = await this.enviarEAguardarBackend([ScarfClientService.Cadastrar(),]);
        return respostas[0];
      } catch (e) {
        return '';
      }
    },

    async atualizarBiometriaCliente(biometriaCadastrada) {
      try {
        const respostas = await this.enviarEAguardarBackend([biometriaApiService.atualizar(biometriaCadastrada, this.comanda.cliente.id),]);
        return respostas[0];
      } catch (e) {
        return '';
      }
    },

    urlRPS(id) {
      let url = apiConfig.getUrlVendaFacil();
      let token = apiConfig.getTokenLogin()
      return `${url}/AutenticacaoPorToken?appName=LinxMicrovixERP&authToken=${token}&rotinaOrigem=ImpressaoRps&identificador=${id}`;
    },

    async mensagemSucessoComandaPreVenda(comanda, identificador) {

      let avulsos = comanda.eventos.filter((p) => (p.servicoAvulso));
      let url = this.urlVendaFacil.preVenda;
      let html = (avulsos.length > 0) ? `<br/><a href=${url} target="_blank">Visualizar Pré-venda</a>` : ``;
      let htmlRPS = `<a href=${this.urlRPS(identificador)} target="_blank">Imprimir RPS</a>`

      if (identificador) {
        var cont = (avulsos.length > 0) ? `<br/><br/>${htmlRPS}` : `${htmlRPS}`
        html = html + cont;
      }

      if (
        comanda.fechada &&
        (comanda.eventos.filter(
          (p) => (p.servicoAvulso && !p.cortesiaAvulso) || !p.avaliacao
        ).length > 0 ||
          comanda.produtos.length > 0)
      )

        await alerts.exibirSucessoHtml(
          "Comanda finalizada com sucesso!",
          html
        );
      else if (
        comanda.fechada &&
        (comanda.eventos.filter(
          (p) => p.servicoAvulso && !p.cortesiaAvulso && p.avaliacao
        ).length > 0 ||
          comanda.produtos.length > 0)
      )

      if(identificador){
        await alerts.exibirSucessoHtml(
          "Comanda finalizada com sucesso!", htmlRPS);
      } else {
        await alerts.exibirSucessoHtml(
          "Comanda finalizada com sucesso!");
      }

    },

    async carregaHorarios() {
      let horarios = [];
      let toleranciaAgendamento =
        this.parametros.configuracoes.toleranciaAgendamento.split(":");
      let toleranciaAgendamentoMinutos =
        +toleranciaAgendamento[0] * 60 + +toleranciaAgendamento[1] * 60;
      let horario = this.converterFormatoHoraMinutoEmMinutos(
        this.parametros.horaInicial
      );
      let horarioFinal = this.converterFormatoHoraMinutoEmMinutos(
        this.parametros.horaFinal
      );
      let minutos = this.parametros.configuracoesServicos.minutosDuracaoLinha;

      try {
        while (horario < horarioFinal) {
          let horarioItem = {
            value: this.converterMinutosEmHora(horario),
            disabled: false,
          };
          horarios.push(horarioItem);
          horario += minutos;
        }

        var dataAtual = new Date();
        var dataEspecificaString = this.comanda.data;
        var partesDataEspecifica = dataEspecificaString
          .split("T")[0]
          .split("-");
        var dataEspecifica = new Date(
          partesDataEspecifica[0],
          partesDataEspecifica[1] - 1,
          partesDataEspecifica[2]
        );

        if (isNaN(dataEspecifica))
          dataEspecifica = new Date(dataEspecificaString);

        dataAtual.setHours(0, 0, 0, 0);
        dataEspecifica.setHours(0, 0, 0, 0);

        if (dataAtual.getTime() === dataEspecifica.getTime())
          this.horarios = this.obterHorariosIndisponiveisDia(
            horarios,
            toleranciaAgendamentoMinutos
          );
        else this.horarios = horarios;
      } catch (e) {
        console.log(e);
      }
    },
    abrirHistoricoSaldoServicos() {
      erpWebAppService.abrirHistoricoSaldoServicos(this.comanda.cliente.id);
    },
    isGuidVazio (guid) {
      const guidVazio = '00000000-0000-0000-0000-000000000000';
      return guid === guidVazio;
    }
  },
};
</script>

<style scoped>
.custom-container {
  width: max-content;
}

.icon-input {
  font-size: 16px;
}

.desconto {
  color: red;
  font-size: 0.8em;
  text-decoration: line-through;
}

.dinheiro {
  color: green;
}

.v-menu__content {
  padding: 0 !important;
}

.text-center {
  text-align: center;
}

.equipamentos {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.status-ativo {
  background-color: #F5FBF8;
  color: #09843A;
  border-radius: 5px;
  width: 15%;
  text-align: center;
}

.status-manutencao {
  background-color: #FFF9EB;
  color: #FFB200;
  border-radius: 5px;
  width: 19%;
  text-align: center;
}

.status-inativo {
  background-color: #FFEDE9;
  color: #C0000C;
  border-radius: 5px;
  width: 10%;
  text-align: center;
}
</style>

@media (min-width: 960px)
<style>
.flex.custom-offset-md1.offset-md1 {

}
</style>

